var media = function(expression, matchCallback, mismatchCallback){
    if (matchMedia) {
        var mediaQuery = window.matchMedia(expression);
        mediaQuery.addListener(widthChange);
        widthChange(mediaQuery);
    }

    function widthChange(mediaQuery) {
        if (mediaQuery.matches){
            matchCallback();
        }else{
            (typeof mismatchCallback !== 'undefined') && mismatchCallback();
        }
    }
}

var isTouch = 'ontouchstart' in document.documentElement
        || (navigator.MaxTouchPoints > 0)
        || (navigator.msMaxTouchPoints > 0);

if (isTouch) { // remove all :hover stylesheets
    try { // prevent exception on browsers not supporting DOM styleSheets properly
        for (var si in document.styleSheets) {
            var styleSheet = document.styleSheets[si];
            if (!styleSheet.rules) continue;

            for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                if (!styleSheet.rules[ri].selectorText) continue;

                if (styleSheet.rules[ri].selectorText.match(':hover')) {
                    styleSheet.deleteRule(ri);
                }
            }
        }
    } catch (ex) {}
}
var stateModule = (function () {

    var $body = $('body'),
        changeHash = function (hash) {
            hash = "#"+hash;
            if (history.pushState) {
                history.pushState(null, null, hash);
            }
            else {
                location.hash = hash;
            }
        },
        changeState = function (url) {
            if (history.pushState) {
                history.pushState(null, null, url);
            }
        },
        parseHash = function(target){
            var base = getBaseUrl()+"/squeeze";
            console.log('base', base, target);
            if(target.indexOf(base)!==-1){
                changeHash(target.replace(base, '').replace(/^\/|\/$/g, ''));
            }
        };

        getBaseUrl = function(){
            var pathArray = location.href.split( '/' );
            console.log('path array', pathArray);
            var protocol = pathArray[0];
            var host = pathArray[2];
            var base =  protocol + '//' + host;
            if(pathArray[3]&&(pathArray[3]=='de'||pathArray[3]=='nl'||pathArray[3]=='en'||pathArray[3]=='miami')){
                 base+= "/"+pathArray[3]
            }
            console.log('path', protocol, host, base, pathArray);
            return base;
        },

        removeHash = function(){
            history.replaceState("", document.title, window.location.pathname);
        };

    return {
        changeHash: changeHash,
        changeState: changeState,
        parseHash: parseHash,
        getBaseUrl: getBaseUrl,
        removeHash: removeHash
    }
})();

// get location hash that has /modal string and load modal

$(document).ready(function(){
    backdropModule.hashOpenModal();
})

$(window).on('hashchange', function() {
    backdropModule.hashOpenModal();
});
(function( $ ) {
    var defaults ={
        col: 1,
        dotted: false,
        swipe: true,
        arrows: true,
        duration: 500,
        carousel: true,
        autoslide: 2000,
        animation: 'ribbon' //ribbon, fade
    }

    var methods = {
        init: function(slider, options){
            var self = this;
            self.$slider = $(slider);
            self.settings = $.extend({}, defaults, self.$slider.data(), options);
            self.$wrapper = self.createWrapper();
            self.$slides = self.assignSlides();

            (self.$slides.length > 1) && self.setup();
            self.setActiveSlide( self.$slides.first() );
        },

        setup: function(){
            var self = this;

            self.assignSlidesOrder();

            //init arows
            if (self.settings.arrows == true){
                self.initArrows();
            }

            //init dots
            if (self.settings.dotted == true){
                self.initDots();
            }    

            //init swipe
            if (self.settings.swipe == true){
                self.initSwipe();
            }

            //init autoslide
            if (typeof self.settings.autoslide == 'number'){
                self.initAutoslide();
            }

            //disable arrows if last/first slide
            if (self.settings.carousel == false){
                self.$slider.on('activeSlideChanged', function(){
                    self.toggleArrowState();
                });
            }
        },

        initSwipe: function(){
            var self = this;

            //describe swipe event
            self.$slider.swipe = function(direction, callback){
                var $this = $(this),
                    isTouching = false,
                    start;

                $this.on('touchstart', startSwipe);  

                function startSwipe() {
                    if (event.touches.length == 1) {
                        start = event.touches[0].pageX;
                        isTouching = true;
                        $this.on('touchmove', swipe);
                    }
                }

                function endSwipe(){
                    $this.off('touchmove');
                    isTouching = false;
                    start = null;
                }   

                function swipe(){
                    if (isTouching){
                        var current = event.touches[0].pageX,
                        delta = start - current;

                        if (Math.abs(delta) >= 30){

                            if (delta > 0 && direction == 'left'){
                                callback();
                            }else if (delta < 0  && direction == 'right'){
                                callback();
                            }
                            endSwipe();
                            event.preventDefault();
                        }
                    }
                }
            }

            //bind swipes
            self.$slider.swipe('right', function(){
                self.bindDirectionClick('prev');
            });

            self.$slider.swipe('left', function(){
                self.bindDirectionClick('next');
            });
        },

        initArrows: function(){
            var self = this;
     
            self.$nextBtn = $('<button/>',{
                addClass: 'slider_next-btn',
                type: 'button'
            }).click(function(){
                self.bindDirectionClick('next');
            });

            self.$prevBtn = $('<button/>',{
                addClass: 'slider_prev-btn',
                type: 'button'
            }).click(function(){
                self.bindDirectionClick('prev');
            });

            self.$slider.append( self.$nextBtn, self.$prevBtn );
        },

        initDots: function(){
            var self = this;

            self.$dotsList = $('<div/>',{
                addClass: 'slider_dots'
            }).appendTo( self.$slider );

            //create dots
            self.$slides.each(function(index) {

                $('<button/>', {
                    addClass: 'slider_dot-btn',
                    type: 'button'
                }).data('slideIndex', index)
                    .appendTo(self.$dotsList);
            });

            self.$dots = self.$slider.find('.slider_dot-btn');

            //toggle active dot
            self.$slider.on('activeSlideChanged', function(){

                self.$dots.removeClass('-active')
                    .filter(function(){
                        return self.$activeSlide.index() == $(this).data('slideIndex');
                    }).addClass('-active');

            });

            //dot binding
            self.$dots.click(function(event) {
                self.bindDotClick( $(this) )
            });
        },

        initAutoslide: function(){
            var self = this;

            var autoslideInterval = setInterval(function(){  

                var slideIndex = self.$activeSlide.data('nextIndex');
                self.goToSlide( slideIndex, 'next' );

            }, self.settings.autoslide);

            self.$prevBtn.add(self.$nextBtn).add(self.$dots).one('click.clearInterval', function(){
                clearInterval(autoslideInterval);
            });

            self.$slider.one('touchstart.clearInterval', function(){
                clearInterval(autoslideInterval);
            })
        },

        bindDotClick: function( $dot ){
            var self = this,
                slideIndex = $dot.data('slideIndex');

            if ( slideIndex > self.$activeSlide.index() ){
                self.goToSlide(slideIndex, 'next');

            }else if ( slideIndex < self.$activeSlide.index() ){
                self.goToSlide(slideIndex, 'prev');
            }
        },

        bindDirectionClick: function(direction){
            var self = this,
                slideIndex = self.$activeSlide.data(direction+'Index');

            self.goToSlide( slideIndex, direction );
        },

        goToSlide: function(slideIndex, direction){
            var self = this;


            if (!self.isAnimate && slideIndex <= self.$slides.length){

                self.isAnimate = true;
                self.$nextSlide = self.$slides.eq( slideIndex );


                if (direction == 'next'){

                    var cssActiveLeft = "-100%",
                        cssNextLeft = "100%";

                }else if (direction == 'prev'){

                    var cssActiveLeft = "100%",
                        cssNextLeft = "-100%";
                }

                switch( self.settings.animation ){
                    case 'ribbon':
                        self.$activeSlide.css({zIndex: 1})
                            .animate({left: cssActiveLeft}, self.settings.duration);

                        self.$nextSlide.css({left: cssNextLeft, zIndex: 2, visibility: 'visible'})
                            .animate({left: 0}, self.settings.duration, function(){
                                self.$activeSlide.finish();
                                self.setActiveSlide( self.$nextSlide );
                                self.isAnimate = false;
                            });
                    break;
                    case 'fade':
                        self.$activeSlide.css({zIndex: 1});

                        self.$nextSlide.css({opacity: 0, zIndex: 2, visibility: 'visible'})
                            .animate({opacity: 1}, self.settings.diration, function(){
                                self.setActiveSlide( self.$nextSlide );
                                self.isAnimate = false;
                            });
                    break;
                }
            }
        },

        setActiveSlide: function( slide ){
            var self = this,
                $slide = $(slide);

            self.$slides.removeClass('-active').css({
                zIndex: '',
                visibility: '',
                left: '',
                opacity: ''
            });
            
            self.$activeSlide = $slide.addClass('-active');
            self.$slider.trigger('activeSlideChanged', [self.$activeSlide]);
        },

        toggleArrowState: function(){
            var self = this;

            if (typeof self.$nextSlide == 'undefined'){
                self.$prevBtn.prop('disabled', true);
                return false;
            }

            (self.$nextSlide.is( self.$slides.last() ) )
                ? self.$nextBtn.prop('disabled', true)
                : self.$nextBtn.prop('disabled', false);
            

            (self.$nextSlide.is( self.$slides.first() ) )
                ? self.$prevBtn.prop('disabled', true)
                : self.$prevBtn.prop('disabled', false);
        },

        assignSlides: function(){
            var self = this;

            if (self.settings.col != 1){

                var $elements = self.$wrapper.children('*');

                for( var i = 0; i < $elements.length; i += self.settings.col ) {
                    $elements.slice(i, i + self.settings.col ).wrapAll("<div class='slide'></div>");
                }
            }

            return self.$wrapper.children('.slide');
        },

        assignSlidesOrder: function(){
            var self = this;

            self.$slides.each(function(index, slide) {
                var $slide = $(slide);

                (index == self.$slides.length - 1)
                    ? $slide.data('nextIndex', 0)
                    : $slide.data('nextIndex', index + 1);

                (index == 0)
                    ? $slide.data('prevIndex', self.$slides.length - 1)
                    : $slide.data('prevIndex', index - 1);

            });
        },

        createWrapper: function(className){
            var self = this;
            self.$slider.wrapInner('<div class="slider_wrapper"></div>');

            return self.$slider.find('.slider_wrapper');
        },

        reinit: function(params){
            var slider = $(this);

            // if (slider.length){
            //     //remove slide wrapper
            //     if (slider.data('cells')){
            //         slider.find('.slide > *').unwrap();
            //     }

            //     //remove controls
            //     slider.find('.slider-control').remove();

            //     //remove ribbon and content
            //     slider.find('.slider-content').replaceWith(slider.find('.slider-ribbon').contents());

            //     if (params){
            //         params = $.parseJSON(params);
                    
            //         //set new params
            //         $.each(params, function (key, value) {
            //             slider.data(key, value);
            //         });
            //     }

            //     //init
            //     slider.lookSlider();
            // }else{
            //     return;
            // }
        }
    };

$.fn.lookSlider = function( method ) {

    if ( methods[method] ) {
        return methods[method].apply( this.data('lookSlider'), Array.prototype.slice.call( arguments, 1 ));
    }
    else if ( typeof method === 'object' || ! method ) {
        return this.each(function() {
            var slider = Object.create( methods );
            slider.init( this, method );
            $.data( this, 'lookSlider', slider );
        });
    }
    else{
        $.error( 'Method ' +  method + ' does not exist' );
    }   
};

})( jQuery );
(function( $ ) {

    var methods = {
        init: function(select, options){
            var self = this;
            self.$select = $(select);
            self.settings = $.extend({}, self.$select.data(), options);

            self.setup();
        },

        setup: function(){
            var self = this;

            self.createDropdown();


            if (self.$select.attr('multiple')){
                self.selectedArray = [];
                self.$dropdown.addClass('-multiple');
            }


            if (self.settings.label){
                self.createLabel();
            }
        },

        createDropdown: function(){
            var self = this;

            self.$dropdown = $('<span/>',{
                addClass: 'dropdown_toggler',
            }).insertAfter(self.$select);

            self.$selected = $('<span/>', {
                addClass: 'dropdown_selected',
            }).appendTo(self.$dropdown);


            //fix it
            self.selectedArray = [self.$select[0].value ];
            self.setSelected(  self.selectedArray );
            self.createDropdownList();

            self.$dropdown.on('click', function(){

                if (self.$dropdown.hasClass('-active')){
                    self.hideOptions();
                    return false;
                }
                self.showOptions();


                $(this).outside('click', function(){
                    self.hideOptions();
                }); 
            });
        },

        showOptions: function(){
            var self = this;

            self.$dropdownList.slideDown(200);
            self.$dropdown.addClass('-active').removeClass('-selected');
        },

        hideOptions: function(){
            var self = this;

            self.$dropdownList.slideUp(200);
            self.$dropdown.removeClass('-active');

            (self.selectedArray.length)
                ? self.$dropdown.addClass('-selected')
                : self.$dropdown.removeClass('-selected');

        },

        selectOption: function(selectedValue){
            var self = this;
            self.$select.val( selectedValue ).change();
            self.hideOptions();
            self.setSelected(selectedValue);
        },

        multiselectOption: function(selectedValue){
            var self = this,
                selectedIndex = self.selectedArray.indexOf(selectedValue);

            ( selectedIndex >= 0 )
               ? self.selectedArray.splice(selectedIndex, 1)
               : self.selectedArray.push(selectedValue);

            self.$select.val( self.selectedArray ).change();
            self.setSelected( self.mapSelectedArray() );
        },

        mapSelectedArray: function(){
            var self = this;
            return self.selectedArray.map(function(element, index){
               return ' ' + self.$options.filter(function(){
                    return $(this).data('value') == element;
               }).text();
            });
        },

        createLabel: function(){
            var self = this;

            self.$label = $('<label/>', {
                addClass: 'dropdown_label',
                text: self.settings.label + ' '
            }).insertBefore(self.$selected)

            self.$selected.appendTo(self.$label);
        },

        createDropdownList: function(){
            var self = this;

            self.$dropdownList = $('<ul/>', {
                addClass: 'dropdown_list'
            }).appendTo(self.$dropdown);

            self.createOptions();
        },

        createOptions: function(){
            var self = this;

            self.defaultText = self.$select.find('option:disabled:selected')[0].value;

            self.$select.find('option:enabled').map(function(index, option) {
                var $selectOption = $(option);

                $option = $('<li/>',{
                    addClass: 'dropdown_option',
                    text: $selectOption.text()
                }).data('value', $selectOption.val());

                $option.appendTo(self.$dropdownList);

            });

            self.$options = self.$dropdownList.find('.dropdown_option');

            self.$options.on('click.lookDropdown', function(event){
                var selectedValue =  $(this).data('value');
                $(this).toggleClass('-selected');

                if (self.$select.attr('multiple') ){
                    self.multiselectOption( selectedValue );
                }else{
                    self.selectOption( selectedValue );
                }

                event.stopPropagation();
            });
        },

        setSelected: function(selected){
            var self = this;

            if (selected.length == 0){
                self.$selected.text( self.defaultText );
            }else if (selected.length == 1){
                self.$selected.text( selected );
            }else{
                self.$selected.text( selected.length + ' selected' );
            }

        },

        disable: function(){
            var self = this;
            self.$dropdown.addClass('-selected -disabled');
            self.$dropdown.off('click');
        },

        reinit: function(){
            var self = this;
            self.$dropdown.remove();
            self.$select.prop('selectedIndex',0);
            self.init( self.$select );
        }
    };

$.fn.lookDropdown = function( method ) {

    if ( methods[method] ) {
        return this.each(function(index, element){
            methods[method].apply( $(element).data('lookDropdown'), Array.prototype.slice.call( arguments, 1 ));
        });
    }
    else if ( typeof method === 'object' || ! method ) {
        return this.each(function() {
            var dropdown = Object.create( methods );
            dropdown.init( this, method );
            $.data( this, 'lookDropdown', dropdown );
        });
    }
    else{
        $.error( 'Method ' +  method + ' does not exist' );
    }   
};

})( jQuery );
$(window).load(function(){
    HTMLMarker = function(lat, lng, address, index){
        this.lat = lat;
        this.lng = lng;
        this.pos = new google.maps.LatLng(lat, lng);
        this.address = address;
        this.index = index;
    }

    HTMLMarker.prototype = new google.maps.OverlayView();
    HTMLMarker.prototype.onRemove = function(){
    }

    //init your html element here
    HTMLMarker.prototype.onAdd = function(){
        div = document.createElement('DIV');
        div.className = "cta-map_marker";
        div.innerHTML = "<span class='cta-map_marker_address'>" + this.address + "</span>";
        var panes = this.getPanes();
        panes.overlayImage.appendChild(div);
    }

    HTMLMarker.prototype.draw = function(){
        var overlayProjection = this.getProjection();
        var position = overlayProjection.fromLatLngToDivPixel(this.pos);
        var panes = this.getPanes();

        panes.overlayImage.children[this.index].style.left = position.x - 170 + 'px';
        panes.overlayImage.children[this.index].style.top = position.y - 80 + 'px';
    }

    $('.cta-map_frame').mapAddress(abbeyGlobal.locationArray);
});

(function($){
    var methods = {
        init: function(element, locationArray){
            var self = this;
            self.element = $(element);
            self.locationArray = abbeyGlobal.locationArray;
            self.style = [
                {
                    elementType: 'geometry',
                    stylers: [{color: '#f5f5f5'}]
                },
                {
                    elementType: 'labels.icon',
                    stylers: [{visibility: 'off'}]
                },
                {
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#616161'}]
                },
                {
                    elementType: 'labels.text.stroke',
                    stylers: [{color: '#f5f5f5'}]
                },
                {
                    featureType: 'administrative.land_parcel',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#bdbdbd'}]
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry',
                    stylers: [{color: '#eeeeee'}]
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#757575'}]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry',
                    stylers: [{color: '#e5e5e5'}]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#9e9e9e'}]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry',
                    stylers: [{color: '#ffffff'}]
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#757575'}]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry',
                    stylers: [{color: '#dadada'}]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#616161'}]
                },
                {
                    featureType: 'road.local',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#9e9e9e'}]
                },
                {
                    featureType: 'transit.line',
                    elementType: 'geometry',
                    stylers: [{color: '#e5e5e5'}]
                },
                {
                    featureType: 'transit.station',
                    elementType: 'geometry',
                    stylers: [{color: '#eeeeee'}]
                },
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [{color: '#c9c9c9'}]
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#9e9e9e'}]
                }
            ];
            self.lat = self.element.data('lat') || self.locationArray[0].lat;
            self.lng = self.element.data('lng') || self.locationArray[0].lng;
            self.address = self.element.data('address') || self.locationArray[0].address;
            self.isSingle = self.element.data('single');

            self.createMap();
        },

        createMap: function(){
            var self = this;

            var isDraggable = true;

            if ( isTouch && window.matchMedia("(max-width: 680px)").matches ){
                isDraggable = false;
            }

            self.map = new google.maps.Map(self.element[0], {
                scrollwheel: false,
                zoom: 15,
                draggable: isDraggable
            });

            self.stylizeMap();

            self.isSingle ? self.addMarker(self.lat, self.lng, self.address, 0) : self.addMarkers();

            self.setMapCenter(self.lat, self.lng);
        },

        setMapCenter: function(lat, lng){
            var self = this,
                latOffset = 0.0007,
                lngOffset = -0.003;

            self.map.setCenter({
                lat: lat + latOffset,
                lng: lng + lngOffset
            });

            self.map.setZoom(15);

        },

        stylizeMap: function(){
            var self = this;
            self.map.setOptions({styles: self.style});
        },

        addMarker: function(lat, lng, address, index ){
            var self = this;
            var htmlMarker = new HTMLMarker(lat, lng, address, index);
            htmlMarker.setMap(self.map);
        },

        addMarkers: function(){
            var self = this;
            self.locationArray.forEach(function(location, index){
                self.addMarker(location.lat, location.lng, location.address, index);
            })
        }
    };

    $.fn.mapAddress = function(method){
        var args = arguments;
        if ( methods[method] ){
            return this.each(function(index, element){
                methods[method].apply($(element).data('mapAddress'), Array.prototype.slice.call(args, 1));
            });
        }
        else if ( typeof method === 'object' || !method ){
            return this.each(function(){
                var element = Object.create(methods);
                element.init(this, method);
                $.data(this, 'mapAddress', element);
            });
        }
        else {
            $.error('Method ' + method + ' does not exist');
        }
    };

})(jQuery);
(function( $ ) {
		var methods = {
				init: function(element){
						var self = this;
						self.$element = $(element);
						self.$selected = self.$element.find('.chosen_selected');
						self.$selectedOption = self.$element.find('.chosen_selected_option');
						self.$options = self.$element.find('.chosen_options');
						self.$option = self.$element.find('.chosen_option');

						self.binding();
				},

				binding: function(){
					var self = this;

					self.$selected.on('click.chosen', function(event) {
						self.openOptions();

						self.$selected.outside('click.chosen tap.chosen', function(){
							self.$selected.removeClass('-active');
							self.$options.removeClass('-active');
						});
					});

					self.$options.click('click.chosen', function(event){
						event.stopPropagation();
					});

					self.$option.on('click.chosen', function(event) {
						self.changeSelected( $(this) );
						self.closeOptions( $(this) );
						//return false;
					});
				},

				openOptions: function(){
					var self = this;

					self.$selected.toggleClass('-active');
					self.$options.toggleClass('-active');
				},

				closeOptions: function($option){
					var self = this;
					self.$selected.removeClass('-active');
					self.$options.removeClass('-active');
					self.$option.removeClass('-active');
					$option.addClass('-active');

				},

				changeSelected: function($option){
					var self = this;
					self.$selectedOption.text( $option.text() )
				}
		};

$.fn.lookChosen = function( method ) {

		if ( methods[method] ) {
				return methods[method].apply( this, Array.prototype.slice.call( arguments, 1 ));
		}
		else if ( typeof method === 'object' || ! method ) {
				return this.each(function() {
						var element = Object.create( methods );
						element.init( this );
						$.data( this, 'lookChosen', element );
				});
		}
		else{
				$.error( 'Method ' +	method + ' does not exist' );
		}	 
};

})( jQuery );
/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
/**
 * Owl carousel
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 * @todo Lazy Load Icon
 * @todo prevent animationend bubling
 * @todo itemsScaleUp
 * @todo Test Zepto
 * @todo stagePadding calculate wrong active classes
 */
;(function($, window, document, undefined) {

	/**
	 * Creates a carousel.
	 * @class The Owl Carousel.
	 * @public
	 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
	 * @param {Object} [options] - The options
	 */
	function Owl(element, options) {

		/**
		 * Current settings for the carousel.
		 * @public
		 */
		this.settings = null;

		/**
		 * Current options set by the caller including defaults.
		 * @public
		 */
		this.options = $.extend({}, Owl.Defaults, options);

		/**
		 * Plugin element.
		 * @public
		 */
		this.$element = $(element);

		/**
		 * Proxied event handlers.
		 * @protected
		 */
		this._handlers = {};

		/**
		 * References to the running plugins of this carousel.
		 * @protected
		 */
		this._plugins = {};

		/**
		 * Currently suppressed events to prevent them from being retriggered.
		 * @protected
		 */
		this._supress = {};

		/**
		 * Absolute current position.
		 * @protected
		 */
		this._current = null;

		/**
		 * Animation speed in milliseconds.
		 * @protected
		 */
		this._speed = null;

		/**
		 * Coordinates of all items in pixel.
		 * @todo The name of this member is missleading.
		 * @protected
		 */
		this._coordinates = [];

		/**
		 * Current breakpoint.
		 * @todo Real media queries would be nice.
		 * @protected
		 */
		this._breakpoint = null;

		/**
		 * Current width of the plugin element.
		 */
		this._width = null;

		/**
		 * All real items.
		 * @protected
		 */
		this._items = [];

		/**
		 * All cloned items.
		 * @protected
		 */
		this._clones = [];

		/**
		 * Merge values of all items.
		 * @todo Maybe this could be part of a plugin.
		 * @protected
		 */
		this._mergers = [];

		/**
		 * Widths of all items.
		 */
		this._widths = [];

		/**
		 * Invalidated parts within the update process.
		 * @protected
		 */
		this._invalidated = {};

		/**
		 * Ordered list of workers for the update process.
		 * @protected
		 */
		this._pipe = [];

		/**
		 * Current state information for the drag operation.
		 * @todo #261
		 * @protected
		 */
		this._drag = {
			time: null,
			target: null,
			pointer: null,
			stage: {
				start: null,
				current: null
			},
			direction: null
		};

		/**
		 * Current state information and their tags.
		 * @type {Object}
		 * @protected
		 */
		this._states = {
			current: {},
			tags: {
				'initializing': [ 'busy' ],
				'animating': [ 'busy' ],
				'dragging': [ 'interacting' ]
			}
		};

		$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {
			this._handlers[handler] = $.proxy(this[handler], this);
		}, this));

		$.each(Owl.Plugins, $.proxy(function(key, plugin) {
			this._plugins[key.charAt(0).toLowerCase() + key.slice(1)]
				= new plugin(this);
		}, this));

		$.each(Owl.Workers, $.proxy(function(priority, worker) {
			this._pipe.push({
				'filter': worker.filter,
				'run': $.proxy(worker.run, this)
			});
		}, this));

		this.setup();
		this.initialize();
	}

	/**
	 * Default options for the carousel.
	 * @public
	 */
	Owl.Defaults = {
		items: 3,
		loop: false,
		center: false,
		rewind: false,
		checkVisibility: true,

		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		freeDrag: false,

		margin: 0,
		stagePadding: 0,

		merge: false,
		mergeFit: true,
		autoWidth: false,

		startPosition: 0,
		rtl: false,

		smartSpeed: 250,
		fluidSpeed: false,
		dragEndSpeed: false,

		responsive: {},
		responsiveRefreshRate: 200,
		responsiveBaseElement: window,

		fallbackEasing: 'swing',
		slideTransition: '',

		info: false,

		nestedItemSelector: false,
		itemElement: 'div',
		stageElement: 'div',

		refreshClass: 'owl-refresh',
		loadedClass: 'owl-loaded',
		loadingClass: 'owl-loading',
		rtlClass: 'owl-rtl',
		responsiveClass: 'owl-responsive',
		dragClass: 'owl-drag',
		itemClass: 'owl-item',
		stageClass: 'owl-stage',
		stageOuterClass: 'owl-stage-outer',
		grabClass: 'owl-grab'
	};

	/**
	 * Enumeration for width.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Width = {
		Default: 'default',
		Inner: 'inner',
		Outer: 'outer'
	};

	/**
	 * Enumeration for types.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Type = {
		Event: 'event',
		State: 'state'
	};

	/**
	 * Contains all registered plugins.
	 * @public
	 */
	Owl.Plugins = {};

	/**
	 * List of workers involved in the update process.
	 */
	Owl.Workers = [ {
		filter: [ 'width', 'settings' ],
		run: function() {
			this._width = this.$element.width();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = this._items && this._items[this.relative(this._current)];
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			this.$stage.children('.cloned').remove();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var margin = this.settings.margin || '',
				grid = !this.settings.autoWidth,
				rtl = this.settings.rtl,
				css = {
					'width': 'auto',
					'margin-left': rtl ? margin : '',
					'margin-right': rtl ? '' : margin
				};

			!grid && this.$stage.children().css(css);

			cache.css = css;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
				merge = null,
				iterator = this._items.length,
				grid = !this.settings.autoWidth,
				widths = [];

			cache.items = {
				merge: false,
				width: width
			};

			while (iterator--) {
				merge = this._mergers[iterator];
				merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;

				cache.items.merge = merge > 1 || cache.items.merge;

				widths[iterator] = !grid ? this._items[iterator].width() : width * merge;
			}

			this._widths = widths;
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			var clones = [],
				items = this._items,
				settings = this.settings,
				// TODO: Should be computed from number of min width items in stage
				view = Math.max(settings.items * 2, 4),
				size = Math.ceil(items.length / 2) * 2,
				repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,
				append = '',
				prepend = '';

			repeat /= 2;

			while (repeat > 0) {
				// Switch to only using appended clones
				clones.push(this.normalize(clones.length / 2, true));
				append = append + items[clones[clones.length - 1]][0].outerHTML;
				clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));
				prepend = items[clones[clones.length - 1]][0].outerHTML + prepend;
				repeat -= 1;
			}

			this._clones = clones;

			$(append).addClass('cloned').appendTo(this.$stage);
			$(prepend).addClass('cloned').prependTo(this.$stage);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				size = this._clones.length + this._items.length,
				iterator = -1,
				previous = 0,
				current = 0,
				coordinates = [];

			while (++iterator < size) {
				previous = coordinates[iterator - 1] || 0;
				current = this._widths[this.relative(iterator)] + this.settings.margin;
				coordinates.push(previous + current * rtl);
			}

			this._coordinates = coordinates;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var padding = this.settings.stagePadding,
				coordinates = this._coordinates,
				css = {
					'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,
					'padding-left': padding || '',
					'padding-right': padding || ''
				};

			this.$stage.css(css);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var iterator = this._coordinates.length,
				grid = !this.settings.autoWidth,
				items = this.$stage.children();

			if (grid && cache.items.merge) {
				while (iterator--) {
					cache.css.width = this._widths[this.relative(iterator)];
					items.eq(iterator).css(cache.css);
				}
			} else if (grid) {
				cache.css.width = cache.items.width;
				items.css(cache.css);
			}
		}
	}, {
		filter: [ 'items' ],
		run: function() {
			this._coordinates.length < 1 && this.$stage.removeAttr('style');
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = cache.current ? this.$stage.children().index(cache.current) : 0;
			cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));
			this.reset(cache.current);
		}
	}, {
		filter: [ 'position' ],
		run: function() {
			this.animate(this.coordinates(this._current));
		}
	}, {
		filter: [ 'width', 'position', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				padding = this.settings.stagePadding * 2,
				begin = this.coordinates(this.current()) + padding,
				end = begin + this.width() * rtl,
				inner, outer, matches = [], i, n;

			for (i = 0, n = this._coordinates.length; i < n; i++) {
				inner = this._coordinates[i - 1] || 0;
				outer = Math.abs(this._coordinates[i]) + padding * rtl;

				if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
					|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
					matches.push(i);
				}
			}

			this.$stage.children('.active').removeClass('active');
			this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');

			this.$stage.children('.center').removeClass('center');
			if (this.settings.center) {
				this.$stage.children().eq(this.current()).addClass('center');
			}
		}
	} ];

	/**
	 * Create the stage DOM element
	 */
	Owl.prototype.initializeStage = function() {
		this.$stage = this.$element.find('.' + this.settings.stageClass);

		// if the stage is already in the DOM, grab it and skip stage initialization
		if (this.$stage.length) {
			return;
		}

		this.$element.addClass(this.options.loadingClass);

		// create stage
		this.$stage = $('<' + this.settings.stageElement + '>', {
			"class": this.settings.stageClass
		}).wrap( $( '<div/>', {
			"class": this.settings.stageOuterClass
		}));

		// append stage
		this.$element.append(this.$stage.parent());
	};

	/**
	 * Create item DOM elements
	 */
	Owl.prototype.initializeItems = function() {
		var $items = this.$element.find('.owl-item');

		// if the items are already in the DOM, grab them and skip item initialization
		if ($items.length) {
			this._items = $items.get().map(function(item) {
				return $(item);
			});

			this._mergers = this._items.map(function() {
				return 1;
			});

			this.refresh();

			return;
		}

		// append content
		this.replace(this.$element.children().not(this.$stage.parent()));

		// check visibility
		if (this.isVisible()) {
			// update view
			this.refresh();
		} else {
			// invalidate width
			this.invalidate('width');
		}

		this.$element
			.removeClass(this.options.loadingClass)
			.addClass(this.options.loadedClass);
	};

	/**
	 * Initializes the carousel.
	 * @protected
	 */
	Owl.prototype.initialize = function() {
		this.enter('initializing');
		this.trigger('initialize');

		this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);

		if (this.settings.autoWidth && !this.is('pre-loading')) {
			var imgs, nestedSelector, width;
			imgs = this.$element.find('img');
			nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
			width = this.$element.children(nestedSelector).width();

			if (imgs.length && width <= 0) {
				this.preloadAutoWidthImages(imgs);
			}
		}

		this.initializeStage();
		this.initializeItems();

		// register event handlers
		this.registerEventHandlers();

		this.leave('initializing');
		this.trigger('initialized');
	};

	/**
	 * @returns {Boolean} visibility of $element
	 *                    if you know the carousel will always be visible you can set `checkVisibility` to `false` to
	 *                    prevent the expensive browser layout forced reflow the $element.is(':visible') does
	 */
	Owl.prototype.isVisible = function() {
		return this.settings.checkVisibility
			? this.$element.is(':visible')
			: true;
	};

	/**
	 * Setups the current settings.
	 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
	 * @todo Support for media queries by using `matchMedia` would be nice.
	 * @public
	 */
	Owl.prototype.setup = function() {
		var viewport = this.viewport(),
			overwrites = this.options.responsive,
			match = -1,
			settings = null;

		if (!overwrites) {
			settings = $.extend({}, this.options);
		} else {
			$.each(overwrites, function(breakpoint) {
				if (breakpoint <= viewport && breakpoint > match) {
					match = Number(breakpoint);
				}
			});

			settings = $.extend({}, this.options, overwrites[match]);
			if (typeof settings.stagePadding === 'function') {
				settings.stagePadding = settings.stagePadding();
			}
			delete settings.responsive;

			// responsive class
			if (settings.responsiveClass) {
				this.$element.attr('class',
					this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + match)
				);
			}
		}

		this.trigger('change', { property: { name: 'settings', value: settings } });
		this._breakpoint = match;
		this.settings = settings;
		this.invalidate('settings');
		this.trigger('changed', { property: { name: 'settings', value: this.settings } });
	};

	/**
	 * Updates option logic if necessery.
	 * @protected
	 */
	Owl.prototype.optionsLogic = function() {
		if (this.settings.autoWidth) {
			this.settings.stagePadding = false;
			this.settings.merge = false;
		}
	};

	/**
	 * Prepares an item before add.
	 * @todo Rename event parameter `content` to `item`.
	 * @protected
	 * @returns {jQuery|HTMLElement} - The item container.
	 */
	Owl.prototype.prepare = function(item) {
		var event = this.trigger('prepare', { content: item });

		if (!event.data) {
			event.data = $('<' + this.settings.itemElement + '/>')
				.addClass(this.options.itemClass).append(item)
		}

		this.trigger('prepared', { content: event.data });

		return event.data;
	};

	/**
	 * Updates the view.
	 * @public
	 */
	Owl.prototype.update = function() {
		var i = 0,
			n = this._pipe.length,
			filter = $.proxy(function(p) { return this[p] }, this._invalidated),
			cache = {};

		while (i < n) {
			if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
				this._pipe[i].run(cache);
			}
			i++;
		}

		this._invalidated = {};

		!this.is('valid') && this.enter('valid');
	};

	/**
	 * Gets the width of the view.
	 * @public
	 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
	 * @returns {Number} - The width of the view in pixel.
	 */
	Owl.prototype.width = function(dimension) {
		dimension = dimension || Owl.Width.Default;
		switch (dimension) {
			case Owl.Width.Inner:
			case Owl.Width.Outer:
				return this._width;
			default:
				return this._width - this.settings.stagePadding * 2 + this.settings.margin;
		}
	};

	/**
	 * Refreshes the carousel primarily for adaptive purposes.
	 * @public
	 */
	Owl.prototype.refresh = function() {
		this.enter('refreshing');
		this.trigger('refresh');

		this.setup();

		this.optionsLogic();

		this.$element.addClass(this.options.refreshClass);

		this.update();

		this.$element.removeClass(this.options.refreshClass);

		this.leave('refreshing');
		this.trigger('refreshed');
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onThrottledResize = function() {
		window.clearTimeout(this.resizeTimer);
		this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onResize = function() {
		if (!this._items.length) {
			return false;
		}

		if (this._width === this.$element.width()) {
			return false;
		}

		if (!this.isVisible()) {
			return false;
		}

		this.enter('resizing');

		if (this.trigger('resize').isDefaultPrevented()) {
			this.leave('resizing');
			return false;
		}

		this.invalidate('width');

		this.refresh();

		this.leave('resizing');
		this.trigger('resized');
	};

	/**
	 * Registers event handlers.
	 * @todo Check `msPointerEnabled`
	 * @todo #261
	 * @protected
	 */
	Owl.prototype.registerEventHandlers = function() {
		if ($.support.transition) {
			this.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));
		}

		if (this.settings.responsive !== false) {
			this.on(window, 'resize', this._handlers.onThrottledResize);
		}

		if (this.settings.mouseDrag) {
			this.$element.addClass(this.options.dragClass);
			this.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });
		}

		if (this.settings.touchDrag){
			this.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));
		}
	};

	/**
	 * Handles `touchstart` and `mousedown` events.
	 * @todo Horizontal swipe threshold as option
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragStart = function(event) {
		var stage = null;

		if (event.which === 3) {
			return;
		}

		if ($.support.transform) {
			stage = this.$stage.css('transform').replace(/.*\(|\)| /g, '').split(',');
			stage = {
				x: stage[stage.length === 16 ? 12 : 4],
				y: stage[stage.length === 16 ? 13 : 5]
			};
		} else {
			stage = this.$stage.position();
			stage = {
				x: this.settings.rtl ?
					stage.left + this.$stage.width() - this.width() + this.settings.margin :
					stage.left,
				y: stage.top
			};
		}

		if (this.is('animating')) {
			$.support.transform ? this.animate(stage.x) : this.$stage.stop()
			this.invalidate('position');
		}

		this.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');

		this.speed(0);

		this._drag.time = new Date().getTime();
		this._drag.target = $(event.target);
		this._drag.stage.start = stage;
		this._drag.stage.current = stage;
		this._drag.pointer = this.pointer(event);

		$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));

		$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {
			var delta = this.difference(this._drag.pointer, this.pointer(event));

			$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));

			if (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {
				return;
			}

			event.preventDefault();

			this.enter('dragging');
			this.trigger('drag');
		}, this));
	};

	/**
	 * Handles the `touchmove` and `mousemove` events.
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragMove = function(event) {
		var minimum = null,
			maximum = null,
			pull = null,
			delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this.difference(this._drag.stage.start, delta);

		if (!this.is('dragging')) {
			return;
		}

		event.preventDefault();

		if (this.settings.loop) {
			minimum = this.coordinates(this.minimum());
			maximum = this.coordinates(this.maximum() + 1) - minimum;
			stage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;
		} else {
			minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
			maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
			pull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;
			stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);
		}

		this._drag.stage.current = stage;

		this.animate(stage.x);
	};

	/**
	 * Handles the `touchend` and `mouseup` events.
	 * @todo #261
	 * @todo Threshold for click event
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragEnd = function(event) {
		var delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this._drag.stage.current,
			direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';

		$(document).off('.owl.core');

		this.$element.removeClass(this.options.grabClass);

		if (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {
			this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
			this.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));
			this.invalidate('position');
			this.update();

			this._drag.direction = direction;

			if (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {
				this._drag.target.one('click.owl.core', function() { return false; });
			}
		}

		if (!this.is('dragging')) {
			return;
		}

		this.leave('dragging');
		this.trigger('dragged');
	};

	/**
	 * Gets absolute position of the closest item for a coordinate.
	 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
	 * @protected
	 * @param {Number} coordinate - The coordinate in pixel.
	 * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.
	 * @return {Number} - The absolute position of the closest item.
	 */
	Owl.prototype.closest = function(coordinate, direction) {
		var position = -1,
			pull = 30,
			width = this.width(),
			coordinates = this.coordinates();

		if (!this.settings.freeDrag) {
			// check closest item
			$.each(coordinates, $.proxy(function(index, value) {
				// on a left pull, check on current index
				if (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {
					position = index;
				// on a right pull, check on previous index
				// to do so, subtract width from value and set position = index + 1
				} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {
					position = index + 1;
				} else if (this.op(coordinate, '<', value)
					&& this.op(coordinate, '>', coordinates[index + 1] !== undefined ? coordinates[index + 1] : value - width)) {
					position = direction === 'left' ? index + 1 : index;
				}
				return position === -1;
			}, this));
		}

		if (!this.settings.loop) {
			// non loop boundries
			if (this.op(coordinate, '>', coordinates[this.minimum()])) {
				position = coordinate = this.minimum();
			} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
				position = coordinate = this.maximum();
			}
		}

		return position;
	};

	/**
	 * Animates the stage.
	 * @todo #270
	 * @public
	 * @param {Number} coordinate - The coordinate in pixels.
	 */
	Owl.prototype.animate = function(coordinate) {
		var animate = this.speed() > 0;

		this.is('animating') && this.onTransitionEnd();

		if (animate) {
			this.enter('animating');
			this.trigger('translate');
		}

		if ($.support.transform3d && $.support.transition) {
			this.$stage.css({
				transform: 'translate3d(' + coordinate + 'px,0px,0px)',
				transition: (this.speed() / 1000) + 's' + (
					this.settings.slideTransition ? ' ' + this.settings.slideTransition : ''
				)
			});
		} else if (animate) {
			this.$stage.animate({
				left: coordinate + 'px'
			}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));
		} else {
			this.$stage.css({
				left: coordinate + 'px'
			});
		}
	};

	/**
	 * Checks whether the carousel is in a specific state or not.
	 * @param {String} state - The state to check.
	 * @returns {Boolean} - The flag which indicates if the carousel is busy.
	 */
	Owl.prototype.is = function(state) {
		return this._states.current[state] && this._states.current[state] > 0;
	};

	/**
	 * Sets the absolute position of the current item.
	 * @public
	 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
	 * @returns {Number} - The absolute position of the current item.
	 */
	Owl.prototype.current = function(position) {
		if (position === undefined) {
			return this._current;
		}

		if (this._items.length === 0) {
			return undefined;
		}

		position = this.normalize(position);

		if (this._current !== position) {
			var event = this.trigger('change', { property: { name: 'position', value: position } });

			if (event.data !== undefined) {
				position = this.normalize(event.data);
			}

			this._current = position;

			this.invalidate('position');

			this.trigger('changed', { property: { name: 'position', value: this._current } });
		}

		return this._current;
	};

	/**
	 * Invalidates the given part of the update routine.
	 * @param {String} [part] - The part to invalidate.
	 * @returns {Array.<String>} - The invalidated parts.
	 */
	Owl.prototype.invalidate = function(part) {
		if ($.type(part) === 'string') {
			this._invalidated[part] = true;
			this.is('valid') && this.leave('valid');
		}
		return $.map(this._invalidated, function(v, i) { return i });
	};

	/**
	 * Resets the absolute position of the current item.
	 * @public
	 * @param {Number} position - The absolute position of the new item.
	 */
	Owl.prototype.reset = function(position) {
		position = this.normalize(position);

		if (position === undefined) {
			return;
		}

		this._speed = 0;
		this._current = position;

		this.suppress([ 'translate', 'translated' ]);

		this.animate(this.coordinates(position));

		this.release([ 'translate', 'translated' ]);
	};

	/**
	 * Normalizes an absolute or a relative position of an item.
	 * @public
	 * @param {Number} position - The absolute or relative position to normalize.
	 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
	 * @returns {Number} - The normalized position.
	 */
	Owl.prototype.normalize = function(position, relative) {
		var n = this._items.length,
			m = relative ? 0 : this._clones.length;

		if (!this.isNumeric(position) || n < 1) {
			position = undefined;
		} else if (position < 0 || position >= n + m) {
			position = ((position - m / 2) % n + n) % n + m / 2;
		}

		return position;
	};

	/**
	 * Converts an absolute position of an item into a relative one.
	 * @public
	 * @param {Number} position - The absolute position to convert.
	 * @returns {Number} - The converted position.
	 */
	Owl.prototype.relative = function(position) {
		position -= this._clones.length / 2;
		return this.normalize(position, true);
	};

	/**
	 * Gets the maximum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.maximum = function(relative) {
		var settings = this.settings,
			maximum = this._coordinates.length,
			iterator,
			reciprocalItemsWidth,
			elementWidth;

		if (settings.loop) {
			maximum = this._clones.length / 2 + this._items.length - 1;
		} else if (settings.autoWidth || settings.merge) {
			iterator = this._items.length;
			if (iterator) {
				reciprocalItemsWidth = this._items[--iterator].width();
				elementWidth = this.$element.width();
				while (iterator--) {
					reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
					if (reciprocalItemsWidth > elementWidth) {
						break;
					}
				}
			}
			maximum = iterator + 1;
		} else if (settings.center) {
			maximum = this._items.length - 1;
		} else {
			maximum = this._items.length - settings.items;
		}

		if (relative) {
			maximum -= this._clones.length / 2;
		}

		return Math.max(maximum, 0);
	};

	/**
	 * Gets the minimum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.minimum = function(relative) {
		return relative ? 0 : this._clones.length / 2;
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.items = function(position) {
		if (position === undefined) {
			return this._items.slice();
		}

		position = this.normalize(position, true);
		return this._items[position];
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.mergers = function(position) {
		if (position === undefined) {
			return this._mergers.slice();
		}

		position = this.normalize(position, true);
		return this._mergers[position];
	};

	/**
	 * Gets the absolute positions of clones for an item.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
	 */
	Owl.prototype.clones = function(position) {
		var odd = this._clones.length / 2,
			even = odd + this._items.length,
			map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };

		if (position === undefined) {
			return $.map(this._clones, function(v, i) { return map(i) });
		}

		return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
	};

	/**
	 * Sets the current animation speed.
	 * @public
	 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
	 * @returns {Number} - The current animation speed in milliseconds.
	 */
	Owl.prototype.speed = function(speed) {
		if (speed !== undefined) {
			this._speed = speed;
		}

		return this._speed;
	};

	/**
	 * Gets the coordinate of an item.
	 * @todo The name of this method is missleanding.
	 * @public
	 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
	 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
	 */
	Owl.prototype.coordinates = function(position) {
		var multiplier = 1,
			newPosition = position - 1,
			coordinate;

		if (position === undefined) {
			return $.map(this._coordinates, $.proxy(function(coordinate, index) {
				return this.coordinates(index);
			}, this));
		}

		if (this.settings.center) {
			if (this.settings.rtl) {
				multiplier = -1;
				newPosition = position + 1;
			}

			coordinate = this._coordinates[position];
			coordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;
		} else {
			coordinate = this._coordinates[newPosition] || 0;
		}

		coordinate = Math.ceil(coordinate);

		return coordinate;
	};

	/**
	 * Calculates the speed for a translation.
	 * @protected
	 * @param {Number} from - The absolute position of the start item.
	 * @param {Number} to - The absolute position of the target item.
	 * @param {Number} [factor=undefined] - The time factor in milliseconds.
	 * @returns {Number} - The time in milliseconds for the translation.
	 */
	Owl.prototype.duration = function(from, to, factor) {
		if (factor === 0) {
			return 0;
		}

		return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
	};

	/**
	 * Slides to the specified item.
	 * @public
	 * @param {Number} position - The position of the item.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.to = function(position, speed) {
		var current = this.current(),
			revert = null,
			distance = position - this.relative(current),
			direction = (distance > 0) - (distance < 0),
			items = this._items.length,
			minimum = this.minimum(),
			maximum = this.maximum();

		if (this.settings.loop) {
			if (!this.settings.rewind && Math.abs(distance) > items / 2) {
				distance += direction * -1 * items;
			}

			position = current + distance;
			revert = ((position - minimum) % items + items) % items + minimum;

			if (revert !== position && revert - distance <= maximum && revert - distance > 0) {
				current = revert - distance;
				position = revert;
				this.reset(current);
			}
		} else if (this.settings.rewind) {
			maximum += 1;
			position = (position % maximum + maximum) % maximum;
		} else {
			position = Math.max(minimum, Math.min(maximum, position));
		}

		this.speed(this.duration(current, position, speed));
		this.current(position);

		if (this.isVisible()) {
			this.update();
		}
	};

	/**
	 * Slides to the next item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.next = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) + 1, speed);
	};

	/**
	 * Slides to the previous item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.prev = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) - 1, speed);
	};

	/**
	 * Handles the end of an animation.
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onTransitionEnd = function(event) {

		// if css2 animation then event object is undefined
		if (event !== undefined) {
			event.stopPropagation();

			// Catch only owl-stage transitionEnd event
			if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
				return false;
			}
		}

		this.leave('animating');
		this.trigger('translated');
	};

	/**
	 * Gets viewport width.
	 * @protected
	 * @return {Number} - The width in pixel.
	 */
	Owl.prototype.viewport = function() {
		var width;
		if (this.options.responsiveBaseElement !== window) {
			width = $(this.options.responsiveBaseElement).width();
		} else if (window.innerWidth) {
			width = window.innerWidth;
		} else if (document.documentElement && document.documentElement.clientWidth) {
			width = document.documentElement.clientWidth;
		} else {
			console.warn('Can not detect viewport width.');
		}
		return width;
	};

	/**
	 * Replaces the current content.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The new content.
	 */
	Owl.prototype.replace = function(content) {
		this.$stage.empty();
		this._items = [];

		if (content) {
			content = (content instanceof jQuery) ? content : $(content);
		}

		if (this.settings.nestedItemSelector) {
			content = content.find('.' + this.settings.nestedItemSelector);
		}

		content.filter(function() {
			return this.nodeType === 1;
		}).each($.proxy(function(index, item) {
			item = this.prepare(item);
			this.$stage.append(item);
			this._items.push(item);
			this._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}, this));

		this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);

		this.invalidate('items');
	};

	/**
	 * Adds an item.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The item content to add.
	 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
	 */
	Owl.prototype.add = function(content, position) {
		var current = this.relative(this._current);

		position = position === undefined ? this._items.length : this.normalize(position, true);
		content = content instanceof jQuery ? content : $(content);

		this.trigger('add', { content: content, position: position });

		content = this.prepare(content);

		if (this._items.length === 0 || position === this._items.length) {
			this._items.length === 0 && this.$stage.append(content);
			this._items.length !== 0 && this._items[position - 1].after(content);
			this._items.push(content);
			this._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		} else {
			this._items[position].before(content);
			this._items.splice(position, 0, content);
			this._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}

		this._items[current] && this.reset(this._items[current].index());

		this.invalidate('items');

		this.trigger('added', { content: content, position: position });
	};

	/**
	 * Removes an item by its position.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {Number} position - The relative position of the item to remove.
	 */
	Owl.prototype.remove = function(position) {
		position = this.normalize(position, true);

		if (position === undefined) {
			return;
		}

		this.trigger('remove', { content: this._items[position], position: position });

		this._items[position].remove();
		this._items.splice(position, 1);
		this._mergers.splice(position, 1);

		this.invalidate('items');

		this.trigger('removed', { content: null, position: position });
	};

	/**
	 * Preloads images with auto width.
	 * @todo Replace by a more generic approach
	 * @protected
	 */
	Owl.prototype.preloadAutoWidthImages = function(images) {
		images.each($.proxy(function(i, element) {
			this.enter('pre-loading');
			element = $(element);
			$(new Image()).one('load', $.proxy(function(e) {
				element.attr('src', e.target.src);
				element.css('opacity', 1);
				this.leave('pre-loading');
				!this.is('pre-loading') && !this.is('initializing') && this.refresh();
			}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));
		}, this));
	};

	/**
	 * Destroys the carousel.
	 * @public
	 */
	Owl.prototype.destroy = function() {

		this.$element.off('.owl.core');
		this.$stage.off('.owl.core');
		$(document).off('.owl.core');

		if (this.settings.responsive !== false) {
			window.clearTimeout(this.resizeTimer);
			this.off(window, 'resize', this._handlers.onThrottledResize);
		}

		for (var i in this._plugins) {
			this._plugins[i].destroy();
		}

		this.$stage.children('.cloned').remove();

		this.$stage.unwrap();
		this.$stage.children().contents().unwrap();
		this.$stage.children().unwrap();
		this.$stage.remove();
		this.$element
			.removeClass(this.options.refreshClass)
			.removeClass(this.options.loadingClass)
			.removeClass(this.options.loadedClass)
			.removeClass(this.options.rtlClass)
			.removeClass(this.options.dragClass)
			.removeClass(this.options.grabClass)
			.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), ''))
			.removeData('owl.carousel');
	};

	/**
	 * Operators to calculate right-to-left and left-to-right.
	 * @protected
	 * @param {Number} [a] - The left side operand.
	 * @param {String} [o] - The operator.
	 * @param {Number} [b] - The right side operand.
	 */
	Owl.prototype.op = function(a, o, b) {
		var rtl = this.settings.rtl;
		switch (o) {
			case '<':
				return rtl ? a > b : a < b;
			case '>':
				return rtl ? a < b : a > b;
			case '>=':
				return rtl ? a <= b : a >= b;
			case '<=':
				return rtl ? a >= b : a <= b;
			default:
				break;
		}
	};

	/**
	 * Attaches to an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The event handler to attach.
	 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
	 */
	Owl.prototype.on = function(element, event, listener, capture) {
		if (element.addEventListener) {
			element.addEventListener(event, listener, capture);
		} else if (element.attachEvent) {
			element.attachEvent('on' + event, listener);
		}
	};

	/**
	 * Detaches from an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The attached event handler to detach.
	 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
	 */
	Owl.prototype.off = function(element, event, listener, capture) {
		if (element.removeEventListener) {
			element.removeEventListener(event, listener, capture);
		} else if (element.detachEvent) {
			element.detachEvent('on' + event, listener);
		}
	};

	/**
	 * Triggers a public event.
	 * @todo Remove `status`, `relatedTarget` should be used instead.
	 * @protected
	 * @param {String} name - The event name.
	 * @param {*} [data=null] - The event data.
	 * @param {String} [namespace=carousel] - The event namespace.
	 * @param {String} [state] - The state which is associated with the event.
	 * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.
	 * @returns {Event} - The event arguments.
	 */
	Owl.prototype.trigger = function(name, data, namespace, state, enter) {
		var status = {
			item: { count: this._items.length, index: this.current() }
		}, handler = $.camelCase(
			$.grep([ 'on', name, namespace ], function(v) { return v })
				.join('-').toLowerCase()
		), event = $.Event(
			[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
			$.extend({ relatedTarget: this }, status, data)
		);

		if (!this._supress[name]) {
			$.each(this._plugins, function(name, plugin) {
				if (plugin.onTrigger) {
					plugin.onTrigger(event);
				}
			});

			this.register({ type: Owl.Type.Event, name: name });
			this.$element.trigger(event);

			if (this.settings && typeof this.settings[handler] === 'function') {
				this.settings[handler].call(this, event);
			}
		}

		return event;
	};

	/**
	 * Enters a state.
	 * @param name - The state name.
	 */
	Owl.prototype.enter = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			if (this._states.current[name] === undefined) {
				this._states.current[name] = 0;
			}

			this._states.current[name]++;
		}, this));
	};

	/**
	 * Leaves a state.
	 * @param name - The state name.
	 */
	Owl.prototype.leave = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			this._states.current[name]--;
		}, this));
	};

	/**
	 * Registers an event or state.
	 * @public
	 * @param {Object} object - The event or state to register.
	 */
	Owl.prototype.register = function(object) {
		if (object.type === Owl.Type.Event) {
			if (!$.event.special[object.name]) {
				$.event.special[object.name] = {};
			}

			if (!$.event.special[object.name].owl) {
				var _default = $.event.special[object.name]._default;
				$.event.special[object.name]._default = function(e) {
					if (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {
						return _default.apply(this, arguments);
					}
					return e.namespace && e.namespace.indexOf('owl') > -1;
				};
				$.event.special[object.name].owl = true;
			}
		} else if (object.type === Owl.Type.State) {
			if (!this._states.tags[object.name]) {
				this._states.tags[object.name] = object.tags;
			} else {
				this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);
			}

			this._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {
				return $.inArray(tag, this._states.tags[object.name]) === i;
			}, this));
		}
	};

	/**
	 * Suppresses events.
	 * @protected
	 * @param {Array.<String>} events - The events to suppress.
	 */
	Owl.prototype.suppress = function(events) {
		$.each(events, $.proxy(function(index, event) {
			this._supress[event] = true;
		}, this));
	};

	/**
	 * Releases suppressed events.
	 * @protected
	 * @param {Array.<String>} events - The events to release.
	 */
	Owl.prototype.release = function(events) {
		$.each(events, $.proxy(function(index, event) {
			delete this._supress[event];
		}, this));
	};

	/**
	 * Gets unified pointer coordinates from event.
	 * @todo #261
	 * @protected
	 * @param {Event} - The `mousedown` or `touchstart` event.
	 * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.
	 */
	Owl.prototype.pointer = function(event) {
		var result = { x: null, y: null };

		event = event.originalEvent || event || window.event;

		event = event.touches && event.touches.length ?
			event.touches[0] : event.changedTouches && event.changedTouches.length ?
				event.changedTouches[0] : event;

		if (event.pageX) {
			result.x = event.pageX;
			result.y = event.pageY;
		} else {
			result.x = event.clientX;
			result.y = event.clientY;
		}

		return result;
	};

	/**
	 * Determines if the input is a Number or something that can be coerced to a Number
	 * @protected
	 * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested
	 * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number
	 */
	Owl.prototype.isNumeric = function(number) {
		return !isNaN(parseFloat(number));
	};

	/**
	 * Gets the difference of two vectors.
	 * @todo #261
	 * @protected
	 * @param {Object} - The first vector.
	 * @param {Object} - The second vector.
	 * @returns {Object} - The difference.
	 */
	Owl.prototype.difference = function(first, second) {
		return {
			x: first.x - second.x,
			y: first.y - second.y
		};
	};

	/**
	 * The jQuery Plugin for the Owl Carousel
	 * @todo Navigation plugin `next` and `prev`
	 * @public
	 */
	$.fn.owlCarousel = function(option) {
		var args = Array.prototype.slice.call(arguments, 1);

		return this.each(function() {
			var $this = $(this),
				data = $this.data('owl.carousel');

			if (!data) {
				data = new Owl(this, typeof option == 'object' && option);
				$this.data('owl.carousel', data);

				$.each([
					'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
				], function(i, event) {
					data.register({ type: Owl.Type.Event, name: event });
					data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
						if (e.namespace && e.relatedTarget !== this) {
							this.suppress([ event ]);
							data[event].apply(this, [].slice.call(arguments, 1));
							this.release([ event ]);
						}
					}, data));
				});
			}

			if (typeof option == 'string' && option.charAt(0) !== '_') {
				data[option].apply(data, args);
			}
		});
	};

	/**
	 * The constructor for the jQuery Plugin
	 * @public
	 */
	$.fn.owlCarousel.Constructor = Owl;

})(window.Zepto || window.jQuery, window, document);

/**
 * AutoRefresh Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto refresh plugin.
	 * @class The Auto Refresh Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoRefresh = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Refresh interval.
		 * @protected
		 * @type {number}
		 */
		this._interval = null;

		/**
		 * Whether the element is currently visible or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._visible = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoRefresh) {
					this.watch();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	AutoRefresh.Defaults = {
		autoRefresh: true,
		autoRefreshInterval: 500
	};

	/**
	 * Watches the element.
	 */
	AutoRefresh.prototype.watch = function() {
		if (this._interval) {
			return;
		}

		this._visible = this._core.isVisible();
		this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);
	};

	/**
	 * Refreshes the element.
	 */
	AutoRefresh.prototype.refresh = function() {
		if (this._core.isVisible() === this._visible) {
			return;
		}

		this._visible = !this._visible;

		this._core.$element.toggleClass('owl-hidden', !this._visible);

		this._visible && (this._core.invalidate('width') && this._core.refresh());
	};

	/**
	 * Destroys the plugin.
	 */
	AutoRefresh.prototype.destroy = function() {
		var handler, property;

		window.clearInterval(this._interval);

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;

})(window.Zepto || window.jQuery, window, document);

/**
 * Lazy Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the lazy plugin.
	 * @class The Lazy Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Lazy = function(carousel) {

		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Already loaded items.
		 * @protected
		 * @type {Array.<jQuery>}
		 */
		this._loaded = [];

		/**
		 * Event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				if (!this._core.settings || !this._core.settings.lazyLoad) {
					return;
				}

				if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
					var settings = this._core.settings,
						n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
						i = ((settings.center && n * -1) || 0),
						position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,
						clones = this._core.clones().length,
						load = $.proxy(function(i, v) { this.load(v) }, this);
					//TODO: Need documentation for this new option
					if (settings.lazyLoadEager > 0) {
						n += settings.lazyLoadEager;
						// If the carousel is looping also preload images that are to the "left"
						if (settings.loop) {
              position -= settings.lazyLoadEager;
              n++;
            }
					}

					while (i++ < n) {
						this.load(clones / 2 + this._core.relative(position));
						clones && $.each(this._core.clones(this._core.relative(position)), load);
						position++;
					}
				}
			}, this)
		};

		// set the default options
		this._core.options = $.extend({}, Lazy.Defaults, this._core.options);

		// register event handler
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Lazy.Defaults = {
		lazyLoad: false,
		lazyLoadEager: 0
	};

	/**
	 * Loads all resources of an item at the specified position.
	 * @param {Number} position - The absolute position of the item.
	 * @protected
	 */
	Lazy.prototype.load = function(position) {
		var $item = this._core.$stage.children().eq(position),
			$elements = $item && $item.find('.owl-lazy');

		if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
			return;
		}

		$elements.each($.proxy(function(index, element) {
			var $element = $(element), image,
                url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src') || $element.attr('data-srcset');

			this._core.trigger('load', { element: $element, url: url }, 'lazy');

			if ($element.is('img')) {
				$element.one('load.owl.lazy', $.proxy(function() {
					$element.css('opacity', 1);
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this)).attr('src', url);
            } else if ($element.is('source')) {
                $element.one('load.owl.lazy', $.proxy(function() {
                    this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
                }, this)).attr('srcset', url);
			} else {
				image = new Image();
				image.onload = $.proxy(function() {
					$element.css({
						'background-image': 'url("' + url + '")',
						'opacity': '1'
					});
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this);
				image.src = url;
			}
		}, this));

		this._loaded.push($item.get(0));
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Lazy.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this._core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;

})(window.Zepto || window.jQuery, window, document);

/**
 * AutoHeight Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto height plugin.
	 * @class The Auto Height Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoHeight = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		this._previousHeight = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight) {
					this.update();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight && e.property.name === 'position'){
					this.update();
				}
			}, this),
			'loaded.owl.lazy': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight
					&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
					this.update();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
		this._intervalId = null;
		var refThis = this;

		// These changes have been taken from a PR by gavrochelegnou proposed in #1575
		// and have been made compatible with the latest jQuery version
		$(window).on('load', function() {
			if (refThis._core.settings.autoHeight) {
				refThis.update();
			}
		});

		// Autoresize the height of the carousel when window is resized
		// When carousel has images, the height is dependent on the width
		// and should also change on resize
		$(window).resize(function() {
			if (refThis._core.settings.autoHeight) {
				if (refThis._intervalId != null) {
					clearTimeout(refThis._intervalId);
				}

				refThis._intervalId = setTimeout(function() {
					refThis.update();
				}, 250);
			}
		});

	};

	/**
	 * Default options.
	 * @public
	 */
	AutoHeight.Defaults = {
		autoHeight: false,
		autoHeightClass: 'owl-height'
	};

	/**
	 * Updates the view.
	 */
	AutoHeight.prototype.update = function() {
		var start = this._core._current,
			end = start + this._core.settings.items,
			lazyLoadEnabled = this._core.settings.lazyLoad,
			visible = this._core.$stage.children().toArray().slice(start, end),
			heights = [],
			maxheight = 0;

		$.each(visible, function(index, item) {
			heights.push($(item).height());
		});

		maxheight = Math.max.apply(null, heights);

		if (maxheight <= 1 && lazyLoadEnabled && this._previousHeight) {
			maxheight = this._previousHeight;
		}

		this._previousHeight = maxheight;

		this._core.$stage.parent()
			.height(maxheight)
			.addClass(this._core.settings.autoHeightClass);
	};

	AutoHeight.prototype.destroy = function() {
		var handler, property;

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] !== 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;

})(window.Zepto || window.jQuery, window, document);

/**
 * Video Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the video plugin.
	 * @class The Video Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Video = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Cache all video URLs.
		 * @protected
		 * @type {Object}
		 */
		this._videos = {};

		/**
		 * Current playing item.
		 * @protected
		 * @type {jQuery}
		 */
		this._playing = null;

		/**
		 * All event handlers.
		 * @todo The cloned content removale is too late
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });
				}
			}, this),
			'resize.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.video && this.isInFullScreen()) {
					e.preventDefault();
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.is('resizing')) {
					this._core.$stage.find('.cloned .owl-video-frame').remove();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position' && this._playing) {
					this.stop();
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				var $element = $(e.content).find('.owl-video');

				if ($element.length) {
					$element.css('display', 'none');
					this.fetch($element, $(e.content));
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Video.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);

		this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
			this.play(e);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Video.Defaults = {
		video: false,
		videoHeight: false,
		videoWidth: false
	};

	/**
	 * Gets the video ID and the type (YouTube/Vimeo/vzaar only).
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {jQuery} item - The item containing the video.
	 */
	Video.prototype.fetch = function(target, item) {
			var type = (function() {
					if (target.attr('data-vimeo-id')) {
						return 'vimeo';
					} else if (target.attr('data-vzaar-id')) {
						return 'vzaar'
					} else {
						return 'youtube';
					}
				})(),
				id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),
				width = target.attr('data-width') || this._core.settings.videoWidth,
				height = target.attr('data-height') || this._core.settings.videoHeight,
				url = target.attr('href');

		if (url) {

			/*
					Parses the id's out of the following urls (and probably more):
					https://www.youtube.com/watch?v=:id
					https://youtu.be/:id
					https://vimeo.com/:id
					https://vimeo.com/channels/:channel/:id
					https://vimeo.com/groups/:group/videos/:id
					https://app.vzaar.com/videos/:id

					Visual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F
			*/

			id = url.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

			if (id[3].indexOf('youtu') > -1) {
				type = 'youtube';
			} else if (id[3].indexOf('vimeo') > -1) {
				type = 'vimeo';
			} else if (id[3].indexOf('vzaar') > -1) {
				type = 'vzaar';
			} else {
				throw new Error('Video URL not supported.');
			}
			id = id[6];
		} else {
			throw new Error('Missing video URL.');
		}

		this._videos[url] = {
			type: type,
			id: id,
			width: width,
			height: height
		};

		item.attr('data-video', url);

		this.thumbnail(target, this._videos[url]);
	};

	/**
	 * Creates video thumbnail.
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {Object} info - The video info object.
	 * @see `fetch`
	 */
	Video.prototype.thumbnail = function(target, video) {
		var tnLink,
			icon,
			path,
			dimensions = video.width && video.height ? 'width:' + video.width + 'px;height:' + video.height + 'px;' : '',
			customTn = target.find('img'),
			srcType = 'src',
			lazyClass = '',
			settings = this._core.settings,
			create = function(path) {
				icon = '<div class="owl-video-play-icon"></div>';

				if (settings.lazyLoad) {
					tnLink = $('<div/>',{
						"class": 'owl-video-tn ' + lazyClass,
						"srcType": path
					});
				} else {
					tnLink = $( '<div/>', {
						"class": "owl-video-tn",
						"style": 'opacity:1;background-image:url(' + path + ')'
					});
				}
				target.after(tnLink);
				target.after(icon);
			};

		// wrap video content into owl-video-wrapper div
		target.wrap( $( '<div/>', {
			"class": "owl-video-wrapper",
			"style": dimensions
		}));

		if (this._core.settings.lazyLoad) {
			srcType = 'data-src';
			lazyClass = 'owl-lazy';
		}

		// custom thumbnail
		if (customTn.length) {
			create(customTn.attr(srcType));
			customTn.remove();
			return false;
		}

		if (video.type === 'youtube') {
			path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
			create(path);
		} else if (video.type === 'vimeo') {
			$.ajax({
				type: 'GET',
				url: '//vimeo.com/api/v2/video/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data[0].thumbnail_large;
					create(path);
				}
			});
		} else if (video.type === 'vzaar') {
			$.ajax({
				type: 'GET',
				url: '//vzaar.com/api/videos/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data.framegrab_url;
					create(path);
				}
			});
		}
	};

	/**
	 * Stops the current video.
	 * @public
	 */
	Video.prototype.stop = function() {
		this._core.trigger('stop', null, 'video');
		this._playing.find('.owl-video-frame').remove();
		this._playing.removeClass('owl-video-playing');
		this._playing = null;
		this._core.leave('playing');
		this._core.trigger('stopped', null, 'video');
	};

	/**
	 * Starts the current video.
	 * @public
	 * @param {Event} event - The event arguments.
	 */
	Video.prototype.play = function(event) {
		var target = $(event.target),
			item = target.closest('.' + this._core.settings.itemClass),
			video = this._videos[item.attr('data-video')],
			width = video.width || '100%',
			height = video.height || this._core.$stage.height(),
			html,
			iframe;

		if (this._playing) {
			return;
		}

		this._core.enter('playing');
		this._core.trigger('play', null, 'video');

		item = this._core.items(this._core.relative(item.index()));

		this._core.reset(item.index());

		html = $( '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>' );
		html.attr( 'height', height );
		html.attr( 'width', width );
		if (video.type === 'youtube') {
			html.attr( 'src', '//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id );
		} else if (video.type === 'vimeo') {
			html.attr( 'src', '//player.vimeo.com/video/' + video.id + '?autoplay=1' );
		} else if (video.type === 'vzaar') {
			html.attr( 'src', '//view.vzaar.com/' + video.id + '/player?autoplay=true' );
		}

		iframe = $(html).wrap( '<div class="owl-video-frame" />' ).insertAfter(item.find('.owl-video'));

		this._playing = item.addClass('owl-video-playing');
	};

	/**
	 * Checks whether an video is currently in full screen mode or not.
	 * @todo Bad style because looks like a readonly method but changes members.
	 * @protected
	 * @returns {Boolean}
	 */
	Video.prototype.isInFullScreen = function() {
		var element = document.fullscreenElement || document.mozFullScreenElement ||
				document.webkitFullscreenElement;

		return element && $(element).parent().hasClass('owl-video-frame');
	};

	/**
	 * Destroys the plugin.
	 */
	Video.prototype.destroy = function() {
		var handler, property;

		this._core.$element.off('click.owl.video');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Video = Video;

})(window.Zepto || window.jQuery, window, document);

/**
 * Animate Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the animate plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Animate = function(scope) {
		this.core = scope;
		this.core.options = $.extend({}, Animate.Defaults, this.core.options);
		this.swapping = true;
		this.previous = undefined;
		this.next = undefined;

		this.handlers = {
			'change.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.previous = this.core.current();
					this.next = e.property.value;
				}
			}, this),
			'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this.swapping = e.type == 'translated';
				}
			}, this),
			'translate.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
					this.swap();
				}
			}, this)
		};

		this.core.$element.on(this.handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Animate.Defaults = {
		animateOut: false,
		animateIn: false
	};

	/**
	 * Toggles the animation classes whenever an translations starts.
	 * @protected
	 * @returns {Boolean|undefined}
	 */
	Animate.prototype.swap = function() {

		if (this.core.settings.items !== 1) {
			return;
		}

		if (!$.support.animation || !$.support.transition) {
			return;
		}

		this.core.speed(0);

		var left,
			clear = $.proxy(this.clear, this),
			previous = this.core.$stage.children().eq(this.previous),
			next = this.core.$stage.children().eq(this.next),
			incoming = this.core.settings.animateIn,
			outgoing = this.core.settings.animateOut;

		if (this.core.current() === this.previous) {
			return;
		}

		if (outgoing) {
			left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
			previous.one($.support.animation.end, clear)
				.css( { 'left': left + 'px' } )
				.addClass('animated owl-animated-out')
				.addClass(outgoing);
		}

		if (incoming) {
			next.one($.support.animation.end, clear)
				.addClass('animated owl-animated-in')
				.addClass(incoming);
		}
	};

	Animate.prototype.clear = function(e) {
		$(e.target).css( { 'left': '' } )
			.removeClass('animated owl-animated-out owl-animated-in')
			.removeClass(this.core.settings.animateIn)
			.removeClass(this.core.settings.animateOut);
		this.core.onTransitionEnd();
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Animate.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this.core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;

})(window.Zepto || window.jQuery, window, document);

/**
 * Autoplay Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author Artus Kolanowski
 * @author David Deutsch
 * @author Tom De Caluwé
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the autoplay plugin.
	 * @class The Autoplay Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Autoplay = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * The autoplay timeout id.
		 * @type {Number}
		 */
		this._call = null;

		/**
		 * Depending on the state of the plugin, this variable contains either
		 * the start time of the timer or the current timer value if it's
		 * paused. Since we start in a paused state we initialize the timer
		 * value.
		 * @type {Number}
		 */
		this._time = 0;

		/**
		 * Stores the timeout currently used.
		 * @type {Number}
		 */
		this._timeout = 0;

		/**
		 * Indicates whenever the autoplay is paused.
		 * @type {Boolean}
		 */
		this._paused = true;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'settings') {
					if (this._core.settings.autoplay) {
						this.play();
					} else {
						this.stop();
					}
				} else if (e.namespace && e.property.name === 'position' && this._paused) {
					// Reset the timer. This code is triggered when the position
					// of the carousel was changed through user interaction.
					this._time = 0;
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoplay) {
					this.play();
				}
			}, this),
			'play.owl.autoplay': $.proxy(function(e, t, s) {
				if (e.namespace) {
					this.play(t, s);
				}
			}, this),
			'stop.owl.autoplay': $.proxy(function(e) {
				if (e.namespace) {
					this.stop();
				}
			}, this),
			'mouseover.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'mouseleave.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.play();
				}
			}, this),
			'touchstart.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'touchend.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause) {
					this.play();
				}
			}, this)
		};

		// register event handlers
		this._core.$element.on(this._handlers);

		// set default options
		this._core.options = $.extend({}, Autoplay.Defaults, this._core.options);
	};

	/**
	 * Default options.
	 * @public
	 */
	Autoplay.Defaults = {
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		autoplaySpeed: false
	};

	/**
	 * Transition to the next slide and set a timeout for the next transition.
	 * @private
	 * @param {Number} [speed] - The animation speed for the animations.
	 */
	Autoplay.prototype._next = function(speed) {
		this._call = window.setTimeout(
			$.proxy(this._next, this, speed),
			this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
		);

		if (this._core.is('interacting') || document.hidden) {
			return;
		}
		this._core.next(speed || this._core.settings.autoplaySpeed);
	}

	/**
	 * Reads the current timer value when the timer is playing.
	 * @public
	 */
	Autoplay.prototype.read = function() {
		return new Date().getTime() - this._time;
	};

	/**
	 * Starts the autoplay.
	 * @public
	 * @param {Number} [timeout] - The interval before the next animation starts.
	 * @param {Number} [speed] - The animation speed for the animations.
	 */
	Autoplay.prototype.play = function(timeout, speed) {
		var elapsed;

		if (!this._core.is('rotating')) {
			this._core.enter('rotating');
		}

		timeout = timeout || this._core.settings.autoplayTimeout;

		// Calculate the elapsed time since the last transition. If the carousel
		// wasn't playing this calculation will yield zero.
		elapsed = Math.min(this._time % (this._timeout || timeout), timeout);

		if (this._paused) {
			// Start the clock.
			this._time = this.read();
			this._paused = false;
		} else {
			// Clear the active timeout to allow replacement.
			window.clearTimeout(this._call);
		}

		// Adjust the origin of the timer to match the new timeout value.
		this._time += this.read() % timeout - elapsed;

		this._timeout = timeout;
		this._call = window.setTimeout($.proxy(this._next, this, speed), timeout - elapsed);
	};

	/**
	 * Stops the autoplay.
	 * @public
	 */
	Autoplay.prototype.stop = function() {
		if (this._core.is('rotating')) {
			// Reset the clock.
			this._time = 0;
			this._paused = true;

			window.clearTimeout(this._call);
			this._core.leave('rotating');
		}
	};

	/**
	 * Pauses the autoplay.
	 * @public
	 */
	Autoplay.prototype.pause = function() {
		if (this._core.is('rotating') && !this._paused) {
			// Pause the clock.
			this._time = this.read();
			this._paused = true;

			window.clearTimeout(this._call);
		}
	};

	/**
	 * Destroys the plugin.
	 */
	Autoplay.prototype.destroy = function() {
		var handler, property;

		this.stop();

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;

})(window.Zepto || window.jQuery, window, document);

/**
 * Navigation Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the navigation plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} carousel - The Owl Carousel.
	 */
	var Navigation = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Indicates whether the plugin is initialized or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._initialized = false;

		/**
		 * The current paging indexes.
		 * @protected
		 * @type {Array}
		 */
		this._pages = [];

		/**
		 * All DOM elements of the user interface.
		 * @protected
		 * @type {Object}
		 */
		this._controls = {};

		/**
		 * Markup for an indicator.
		 * @protected
		 * @type {Array.<String>}
		 */
		this._templates = [];

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * Overridden methods of the carousel.
		 * @protected
		 * @type {Object}
		 */
		this._overrides = {
			next: this._core.next,
			prev: this._core.prev,
			to: this._core.to
		};

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.push('<div class="' + this._core.settings.dotClass + '">' +
						$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');
				}
			}, this),
			'added.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 0, this._templates.pop());
				}
			}, this),
			'remove.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 1);
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.draw();
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && !this._initialized) {
					this._core.trigger('initialize', null, 'navigation');
					this.initialize();
					this.update();
					this.draw();
					this._initialized = true;
					this._core.trigger('initialized', null, 'navigation');
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._initialized) {
					this._core.trigger('refresh', null, 'navigation');
					this.update();
					this.draw();
					this._core.trigger('refreshed', null, 'navigation');
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Navigation.Defaults, this._core.options);

		// register event handlers
		this.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 * @todo Rename `slideBy` to `navBy`
	 */
	Navigation.Defaults = {
		nav: false,
		navText: [
			'<span aria-label="' + 'Previous' + '">&#x2039;</span>',
			'<span aria-label="' + 'Next' + '">&#x203a;</span>'
		],
		navSpeed: false,
		navElement: 'button type="button" role="presentation"',
		navContainer: false,
		navContainerClass: 'owl-nav',
		navClass: [
			'owl-prev',
			'owl-next'
		],
		slideBy: 1,
		dotClass: 'owl-dot',
		dotsClass: 'owl-dots',
		dots: true,
		dotsEach: false,
		dotsData: false,
		dotsSpeed: false,
		dotsContainer: false
	};

	/**
	 * Initializes the layout of the plugin and extends the carousel.
	 * @protected
	 */
	Navigation.prototype.initialize = function() {
		var override,
			settings = this._core.settings;

		// create DOM structure for relative navigation
		this._controls.$relative = (settings.navContainer ? $(settings.navContainer)
			: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$previous = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[0])
			.html(settings.navText[0])
			.prependTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.prev(settings.navSpeed);
			}, this));
		this._controls.$next = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[1])
			.html(settings.navText[1])
			.appendTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.next(settings.navSpeed);
			}, this));

		// create DOM structure for absolute navigation
		if (!settings.dotsData) {
			this._templates = [ $('<button role="button">')
				.addClass(settings.dotClass)
				.append($('<span>'))
				.prop('outerHTML') ];
		}

		this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)
			: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$absolute.on('click', 'button', $.proxy(function(e) {
			var index = $(e.target).parent().is(this._controls.$absolute)
				? $(e.target).index() : $(e.target).parent().index();

			e.preventDefault();

			this.to(index, settings.dotsSpeed);
		}, this));

		/*$el.on('focusin', function() {
			$(document).off(".carousel");

			$(document).on('keydown.carousel', function(e) {
				if(e.keyCode == 37) {
					$el.trigger('prev.owl')
				}
				if(e.keyCode == 39) {
					$el.trigger('next.owl')
				}
			});
		});*/

		// override public methods of the carousel
		for (override in this._overrides) {
			this._core[override] = $.proxy(this[override], this);
		}
	};

	/**
	 * Destroys the plugin.
	 * @protected
	 */
	Navigation.prototype.destroy = function() {
		var handler, control, property, override, settings;
		settings = this._core.settings;

		for (handler in this._handlers) {
			this.$element.off(handler, this._handlers[handler]);
		}
		for (control in this._controls) {
			if (control === '$relative' && settings.navContainer) {
				this._controls[control].html('');
			} else {
				this._controls[control].remove();
			}
		}
		for (override in this.overides) {
			this._core[override] = this._overrides[override];
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	/**
	 * Updates the internal state.
	 * @protected
	 */
	Navigation.prototype.update = function() {
		var i, j, k,
			lower = this._core.clones().length / 2,
			upper = lower + this._core.items().length,
			maximum = this._core.maximum(true),
			settings = this._core.settings,
			size = settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items;

		if (settings.slideBy !== 'page') {
			settings.slideBy = Math.min(settings.slideBy, settings.items);
		}

		if (settings.dots || settings.slideBy == 'page') {
			this._pages = [];

			for (i = lower, j = 0, k = 0; i < upper; i++) {
				if (j >= size || j === 0) {
					this._pages.push({
						start: Math.min(maximum, i - lower),
						end: i - lower + size - 1
					});
					if (Math.min(maximum, i - lower) === maximum) {
						break;
					}
					j = 0, ++k;
				}
				j += this._core.mergers(this._core.relative(i));
			}
		}
	};

	/**
	 * Draws the user interface.
	 * @todo The option `dotsData` wont work.
	 * @protected
	 */
	Navigation.prototype.draw = function() {
		var difference,
			settings = this._core.settings,
			disabled = this._core.items().length <= settings.items,
			index = this._core.relative(this._core.current()),
			loop = settings.loop || settings.rewind;

		this._controls.$relative.toggleClass('disabled', !settings.nav || disabled);

		if (settings.nav) {
			this._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));
			this._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));
		}

		this._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);

		if (settings.dots) {
			difference = this._pages.length - this._controls.$absolute.children().length;

			if (settings.dotsData && difference !== 0) {
				this._controls.$absolute.html(this._templates.join(''));
			} else if (difference > 0) {
				this._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));
			} else if (difference < 0) {
				this._controls.$absolute.children().slice(difference).remove();
			}

			this._controls.$absolute.find('.active').removeClass('active');
			this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');
		}
	};

	/**
	 * Extends event data.
	 * @protected
	 * @param {Event} event - The event object which gets thrown.
	 */
	Navigation.prototype.onTrigger = function(event) {
		var settings = this._core.settings;

		event.page = {
			index: $.inArray(this.current(), this._pages),
			count: this._pages.length,
			size: settings && (settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items)
		};
	};

	/**
	 * Gets the current page position of the carousel.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.current = function() {
		var current = this._core.relative(this._core.current());
		return $.grep(this._pages, $.proxy(function(page, index) {
			return page.start <= current && page.end >= current;
		}, this)).pop();
	};

	/**
	 * Gets the current succesor/predecessor position.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.getPosition = function(successor) {
		var position, length,
			settings = this._core.settings;

		if (settings.slideBy == 'page') {
			position = $.inArray(this.current(), this._pages);
			length = this._pages.length;
			successor ? ++position : --position;
			position = this._pages[((position % length) + length) % length].start;
		} else {
			position = this._core.relative(this._core.current());
			length = this._core.items().length;
			successor ? position += settings.slideBy : position -= settings.slideBy;
		}

		return position;
	};

	/**
	 * Slides to the next item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.next = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
	};

	/**
	 * Slides to the previous item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.prev = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
	};

	/**
	 * Slides to the specified item or page.
	 * @public
	 * @param {Number} position - The position of the item or page.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
	 */
	Navigation.prototype.to = function(position, speed, standard) {
		var length;

		if (!standard && this._pages.length) {
			length = this._pages.length;
			$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
		} else {
			$.proxy(this._overrides.to, this._core)(position, speed);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;

})(window.Zepto || window.jQuery, window, document);

/**
 * Hash Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the hash plugin.
	 * @class The Hash Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Hash = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Hash index for the items.
		 * @protected
		 * @type {Object}
		 */
		this._hashes = {};

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.startPosition === 'URLHash') {
					$(window).trigger('hashchange.owl.navigation');
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					var hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');

					if (!hash) {
						return;
					}

					this._hashes[hash] = e.content;
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position') {
					var current = this._core.items(this._core.relative(this._core.current())),
						hash = $.map(this._hashes, function(item, hash) {
							return item === current ? hash : null;
						}).join();

					if (!hash || window.location.hash.slice(1) === hash) {
						return;
					}

					window.location.hash = hash;
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Hash.Defaults, this._core.options);

		// register the event handlers
		this.$element.on(this._handlers);

		// register event listener for hash navigation
		$(window).on('hashchange.owl.navigation', $.proxy(function(e) {
			var hash = window.location.hash.substring(1),
				items = this._core.$stage.children(),
				position = this._hashes[hash] && items.index(this._hashes[hash]);

			if (position === undefined || position === this._core.current()) {
				return;
			}

			this._core.to(this._core.relative(position), false, true);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Hash.Defaults = {
		URLhashListener: false
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Hash.prototype.destroy = function() {
		var handler, property;

		$(window).off('hashchange.owl.navigation');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;

})(window.Zepto || window.jQuery, window, document);

/**
 * Support Plugin
 *
 * @version 2.3.4
 * @author Vivid Planet Software GmbH
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	var style = $('<support>').get(0).style,
		prefixes = 'Webkit Moz O ms'.split(' '),
		events = {
			transition: {
				end: {
					WebkitTransition: 'webkitTransitionEnd',
					MozTransition: 'transitionend',
					OTransition: 'oTransitionEnd',
					transition: 'transitionend'
				}
			},
			animation: {
				end: {
					WebkitAnimation: 'webkitAnimationEnd',
					MozAnimation: 'animationend',
					OAnimation: 'oAnimationEnd',
					animation: 'animationend'
				}
			}
		},
		tests = {
			csstransforms: function() {
				return !!test('transform');
			},
			csstransforms3d: function() {
				return !!test('perspective');
			},
			csstransitions: function() {
				return !!test('transition');
			},
			cssanimations: function() {
				return !!test('animation');
			}
		};

	function test(property, prefixed) {
		var result = false,
			upper = property.charAt(0).toUpperCase() + property.slice(1);

		$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {
			if (style[property] !== undefined) {
				result = prefixed ? property : true;
				return false;
			}
		});

		return result;
	}

	function prefixed(property) {
		return test(property, true);
	}

	if (tests.csstransitions()) {
		/* jshint -W053 */
		$.support.transition = new String(prefixed('transition'))
		$.support.transition.end = events.transition.end[ $.support.transition ];
	}

	if (tests.cssanimations()) {
		/* jshint -W053 */
		$.support.animation = new String(prefixed('animation'))
		$.support.animation.end = events.animation.end[ $.support.animation ];
	}

	if (tests.csstransforms()) {
		/* jshint -W053 */
		$.support.transform = new String(prefixed('transform'));
		$.support.transform3d = tests.csstransforms3d();
	}

})(window.Zepto || window.jQuery, window, document);
(function( $ ) {

	//check if Safari

	

	//init sliders
	$('.slider').lookSlider({
		dotted: true,
		autoslide: 5000
	});

	// check if browser supports date inputs
	function checkDateInput() {
		var input = document.createElement('input');
		input.setAttribute('type','date');
	
		var notADateValue = 'not-a-date';
		input.setAttribute('value', notADateValue); 
		
		var isDate = (input.value !== notADateValue);
		input.remove();
		return isDate;
	}


	//init datepicker if safari desktop
	var isTouch = 'ontouchstart' in document.documentElement
        || (navigator.MaxTouchPoints > 0)
		|| (navigator.msMaxTouchPoints > 0);
	
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	
	//enable jquery ui datepicker if Safari desktop
	if(!checkDateInput() && !isTouch){
		$('input.wpcf7-form-control[type="date"]').datepicker({ dateFormat: 'dd/mm/yy' });
	}

	$.datepicker.setDefaults(
		$.extend(
		  {'dateFormat':'dd/mm/yy'},
		  $.datepicker.regional['en']
		)
	);

	$datepicker = $('input.ari-datepicker');

	$datepicker.datepicker({ dateFormat: 'dd/mm/yy' });


	

	//parallax

	if ( !isTouch && window.matchMedia("(min-width: 768px)").matches ){
		var s = skrollr.init({
			forceHeight: false
		});
	}

	//chosen

	$('.chosen').lookChosen();

	//input file
	$('.input-file input[type=file]').change(function(){
		var $inputFile = $(this)[0],
	    $fileSpan =$('<span/>'),
			$label = $(this).closest('.input-file'),
			files = $inputFile.files;

		(files.length <= 1)
			? $fileSpan.text( files[0].name )
			: $fileSpan.text( files[0].name + '...');

	  if (typeof $label.data('span') != 'undefined')
			$label.data('span').remove();


		$label.data('span', $fileSpan).after($fileSpan);

  });


	// Contact form 7 tweaks

  $(document).on('wpcf7:spam wpcf7:invalid wpcf7:mailsent wpcf7:mailfailed', function () {
  	$('.wpcf7 .submit').removeClass('submit--disabled');
  	$('.wpcf7 .submit').removeAttr('disabled', 'disabled');

    setTimeout(
      function () {
        $('.wpcf7-response-output').slideUp('slow');
      }, 7000);
  });

  $('.wpcf7').on('submit', function () {
  	$('.wpcf7 .submit').addClass('submit--disabled');
  	$('.wpcf7 .submit').attr('disabled', 'disabled');
  });

  $(".wpcf7 input").on('change', function(){
    if($(this).hasClass("wpcf7-not-valid"))
      $(this).removeClass("wpcf7-not-valid");
  });
  // $(".wpcf7-not-valid").on( "change", function() {
  //     console.log( $( this ).text() );
  // });

})( jQuery );
var backdropModule = (function(){

    var $body = $('body'),
        $backdrop = $('.backdrop'),
        $wrapper = $('.wrapper'),
        $modalOpenBtn = $('[data-modal]'),
        $modalCloseBtn = $('.modal_close-btn'),
        modalShowed = false,

        showModalId = function(modalId){
            var $modal = $(modalId);

            $body.addClass('backstage');
            $body.addClass('modal-open');
            $backdrop.addClass('-active');
            $wrapper.addClass('-squeeze');
            $modal.addClass('-active');

            initModalContent($modal);
        },

        showModalAjax = function(url, $btn){
            if($btn)
            $btn.addClass('-loading');
                $backdrop.find('.backdrop_modal.modal').remove();
                var $modal = $('<div/>', {
                    addClass: 'backdrop_modal modal'
                });

                $modal.appendTo($backdrop);
                $modal.html('');
                var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                var attribute = isSafari ? "onmousewheel='' " : "";
                $modal.html("<iframe id='modal-iframe' scrolling='no' "+attribute+" width='100%' src='"+url+"' class='squeeze-page-iframe'></iframe>");
                var $iframe = document.getElementById('modal-iframe');
                $iframe.addEventListener('load', function(){
                    $body.addClass('backstage');
                    $body.addClass('modal-open');
                    $backdrop.addClass('-active');
                    $wrapper.addClass('-squeeze');
                    $modal.addClass('-active');
                    if(isSafari){
                        $modal.addClass('safari');
                    }
                    initModalContent($modal);
                    if($btn)
                        $btn.removeClass('-loading');
                        squeeezePageShortcodeModule.triggerSqueezeEvent();
                }, false)

        },

        closeModal = function(){
            var $modal = $('.backdrop_modal.-active');
            $modal.find('.squeeze-page-iframe').remove();
            $modal.removeClass('-active');
            $wrapper.removeClass('-squeeze');
            $backdrop.removeClass('-active');
            $body.removeClass('backstage');
            $body.removeClass('modal-open');
            modalShowed = false;
            stateModule.changeState(window.location.href.split('#')[0]);
            setTimeout(function(){
                if( $('.ari-refresh-captcha').length > 0){
                    captchaModule.refreshCaptcha();
                }
            }, 1000);
        },

        hashOpenModal = function(){
            var squeezeHash = window.location.hash;
            console.log('squeezeHash', squeezeHash);
            if( ari_squeeze && ari_squeeze.indexOf(squeezeHash.replace("#", '')) !== -1 ){
                var url = ari_settings['site_url']+"/squeeze";
                var modalUrl = url + squeezeHash.replace("#", '/');
                showModalAjax( modalUrl, undefined);
            }
        },

        initModalContent = function($modal){
            $modal.find('.cta-map_frame').mapAddress(window.locationArray);
        };

    $modalOpenBtn.set('click', function(event){

        if ( !modalShowed ){
            modalShowed = true;
            var $btn = $(this),
                target = $btn.data('modal');
            event.stopPropagation();

            (target.indexOf('#') == 0)
                ? showModalId(target)
                : showModalAjax(target, $btn);
            
            stateModule.parseHash(target);
        }

        return false;

    });

    $modalCloseBtn.set('click', function(){
        closeModal();
    });

    return {
        closeModal: closeModal,
        showModalAjax: showModalAjax,
        hashOpenModal: hashOpenModal,
    }
})();

var body = $('body');

var tabsModule = (function(){

	var $tabLink = $('.tabs_link'),
		$tabContent = $('.tabs_content'),

	showContent = function(contentId){
		$contentToShow = $(contentId);

		$tabContent.refresh()
			.removeClass('-active');

		$contentToShow.addClass('-active');

		setHash(contentId);
		toggleTabLink(contentId);
		//ipad hack

		if ($contentToShow.find('.slider').height() == 0){
			$contentToShow.find('.slider').height( $contentToShow.find('.facility_details_image').height() );			
		}
	},

	toggleTabLink = function(contentId){
		$tabLinkActive = $tabLink.refresh().filter(function(){
			return $(this).attr('href') == contentId;
 		});

		$tabLink.refresh()
			.removeClass('-active');

 		$tabLinkActive.addClass('-active');
	},

	showContentByHash = function(){
		var contentId = window.location.hash,	
		isContentExist = $tabContent.refresh().filter(function(){
			return $(this).attr('id') == contentId.replace('#', '');
		}).length;

		isContentExist && showContent(contentId);
	},

	setHash = function(hash){
		var x = window.pageXOffset,
        	y = window.pageYOffset;

		window.location.hash = hash;
		window.scrollTo(x, y);
	}


	$tabLink.click(function() {
		var contentId = $(this).attr('href');
		showContent(contentId);
		return false;
	});


	return{
		showContentByHash: showContentByHash
	}

})();

tabsModule.showContentByHash();


$(window).on("hashchange", function(){
    return false;
});
var dataTabsModule = (function(){

	var $dataTabToggler = $('.data_tabs_toggler'),
		$dataTabs = $dataTabToggler.next('.data_tabs'),
		$dataTabsLink = $('.data_tabs_link'),
		$dataFluidTabsLink = $('.data_tabs.-small .data_tabs_link');

		toggleTabs = function(){
			$dataTabs.slideToggle();
			$dataTabToggler.toggleClass('-active');
		},

		resetTabs = function(){
			$dataTabs.removeAttr('style');
			$dataTabToggler.removeClass('-active');
		},

		storePageOffset = function(){
        	var pageY = window.pageYOffset,
        		dataTabsY = $('.data_tabs').offset().top,
        		pageOffset = dataTabsY - pageY;

			window.sessionStorage.setItem('pageOffset', pageOffset);
		},

		//apply scroll position while switching between "page tabs"
		applyPageOffset = function(){
			var pageY = window.sessionStorage.getItem('pageOffset');

			if (pageY > 0){

				$dataTabs.show();

				var dataTabsY = $('.data_tabs').offset().top,
					pageOffset = dataTabsY - pageY;

				window.scrollTo(0, pageOffset);
				window.sessionStorage.setItem('pageOffset', 0);
			}
		}

	$dataTabToggler.click(function() {
		toggleTabs();
	});

	$dataTabsLink.click(function(event) {
		storePageOffset();
	});

	media('screen and (min-width: 680px) and (max-width: 1000px)', function(){
		if(!isTouch){
			$dataFluidTabsLink.set('tap', function(){
				var $parentTab = $(this).parent();
				if ( !$parentTab.hasClass('-hover') ){
					$dataFluidTabsLink.parent().removeClass('-hover');
					$parentTab.addClass('-hover');
					//event.preventDefault();
				}
				return true;
			});
		}
	}, function(){
		$dataFluidTabsLink.unset('tap');
	});

	return{
		reset: resetTabs,
		applyPageOffset: applyPageOffset
	}
})();


if ( $('.data_tabs').length ){
	dataTabsModule.applyPageOffset();
}

media('screen and (min-width: 680px)', function(){
	dataTabsModule.reset();
});
var dataAccordion = (function (){

	var $menuLinks = $('.data-accordion_menu_link'),
		$subMenus = $('.data-accordion_submenu'),
		$mainContent = $('.data-accordion_content'),
		$subMenuLinks = $('.data-accordion_submenu_link'),
		$mobileContents = $('.data-accordion_content-mobile'),
        $breadcrumbs = $('.breadcrumbs_list'),
		mainPageSlug = $('.data-accordion').data('main-slug'),

		openSub = function($menuLink){
			var $menuItem = $menuLink.closest('.data-accordion_menu_item'),
				$subMenu = $menuItem.find('.data-accordion_submenu');

			$subMenu.slideDown().addClass('-active');
			$menuLink.addClass('-active');
		},

		closeSub = function($menuLink){
			var $menuItem = $menuLink.closest('.data-accordion_menu_item'),
				$subMenu = $menuItem.find('.data-accordion_submenu');

			$subMenu.slideUp(function(){
				$subMenu.removeClass('-active');
			});
			$menuLink.removeClass('-active');
		},

		showContent = function($menuLink){
			var page_id = $menuLink.attr('data-page-id');

			$menuLink.addClass('-active');
			$mainContent.addClass('-loading');


			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: 'action=get_module_content&id=' + page_id

			}).success(function(data){
				$mainContent.html(data).removeClass('-loading');
                changeBreadcrumbs($menuLink);
            });

            toggleMobileContent($menuLink);
		},

		deactivateSubmenu = function(){
			$subMenuLinks.refresh()
				.filter('.-active')
				.removeClass('-active');

			$mobileContents.refresh()
				.filter('.-active')
				.removeClass('-active')
				.slideUp();
		},

		toggleMobileContent = function($link){
			var page_id = $link.attr('data-page-id'),
				$menuItem = $link.parent(),
				$mobileContent = $menuItem.children('.data-accordion_content-mobile');

			if ( $mobileContent.find('*').length == 0 ) {
				$.ajax({
					url: ajaxurl,
					type: 'GET',
					data: 'action=get_module_content&id=' + page_id
				}).success(function(data){
					$mobileContent.html(data).addClass('-active').slideDown();
				});
			}else{
				$mobileContent.addClass('-active').slideDown();
			}

		},

        changeBreadcrumbs = function($link){
            var $breadcrumbModulesLink = $breadcrumbs.find('a').filter(function(){
                var $breadcrumbLink = $(this);

                if ($breadcrumbLink.attr('href').match('/'+ mainPageSlug +'/') != null){
                    return $breadcrumbLink.attr('href').match('/'+ mainPageSlug +'/').length == 1;
                }
            }).first();

            var $nextBreadcrumbs = $breadcrumbModulesLink.next('span');
            $nextBreadcrumbs.remove();

            var $breadcrumbPlaceholder = $breadcrumbModulesLink.closest('span');

            if ( $link.hasClass('data-accordion_submenu_link') ){
                var $primaryLink = $link.closest('.data-accordion_menu_item').children('.data-accordion_menu_link'),
                    $primaryBreadcrumb = createBreadcrumb($primaryLink, false);

                $primaryBreadcrumb.appendTo( $breadcrumbPlaceholder );
                $breadcrumbPlaceholder = $primaryBreadcrumb;
            }

            createBreadcrumb($link, true).appendTo($breadcrumbPlaceholder);
        },

        createBreadcrumb = function($link, isLast){

            if (isLast){
                var $breadcrumb = $('<span/>', {
                    addClass: 'breadcrumb_last',
                    text: $link.text()
                });
            }else{
                var $breadcrumb = $('<span/>', {
                    rel: 'v:child',
                    typeof: 'v:Breadcrumb',
                });

                $('<a/>',{
                    rel: 'v:url',
                    property: 'v:title',
                    href: $link.attr('href'),
                    text: $link.text()
                }).appendTo($breadcrumb);

                $breadcrumb.append(' - ');
            }

            return $breadcrumb;

        },

		changeUrl = function($link){
			var url = $link.attr('href'),
				state = {
					url: url
				};

			window.history.pushState(state, 'Abbey', url);
		};


	$menuLinks.set('click', function(event){


        var $menuLink = $(this);

		if ( !$menuLink.hasClass('-active') ){
			closeSub( $menuLinks.refresh().filter('.-active') );
			openSub( $menuLink );
		}

		if (!event.isTrigger){
			changeUrl($menuLink);
		}

		deactivateSubmenu();
		showContent( $menuLink );



        return false;
	});

	$subMenuLinks.set('click', function(event){
		var $subMenuLink = $(this);

		deactivateSubmenu();
		showContent( $subMenuLink );

		if (!event.isTrigger){
			changeUrl($subMenuLink);
		}else{
			var $menuLink = $subMenuLink.closest('.data-accordion_menu_item').find('.data-accordion_menu_link');
			
			if (!$menuLink.hasClass('-active')){
				closeSub( $menuLinks.refresh().filter('.-active') );
				openSub( $menuLink );
			}
		}

		return false;
	});

	window.addEventListener('popstate', function(event) {
		if (event.state){
			$('a[href="'+event.state.url+'"]').trigger('click')
		}else{
			$('.data-accordion_menu_link').first().trigger('click');
		}
	});

	media('screen and (max-width: 840px)', function(){
		$mobileContents.filter(':not(.-active)').hide();
	});

});

window.onload = function(){
	if($('.data_tabs_toggler').length>0){
		var toggler = $('.data_tabs_toggler');
		var tabs  = $('.data_tabs_toggler').siblings('.data_tabs');
		var active = $(tabs).find('.-active');
		if(active.length>0){
			toggler.addClass('-active');
			toggler.siblings('.data_tabs').slideDown();
		};
	}
};

$('.data-accordion').length && dataAccordion();
(function () {

    $('.menu-item_link.-has-sub').hover(function () {
        $(this).find('.sub-container').stop(true, true).slideDown(300);
    }, function () {
        $(this).find('.sub-container').stop(true, true).delay(200).slideUp(200);
    });

})();

var headerLocationController = (function () {

    var $chosen = $('.header_location_chosen'),
        $option = $chosen.find('.chosen_option'),

        trigger = function (location) {
            $option.filter(function () {
                return $(this).data('location') == location
            }).trigger('click.chosen');
        };

    $option.on('click', function () {
        var selectedOption = $(this).data('location');
        $(document).trigger('changeLocation', [selectedOption]);
    });

    return {
        trigger: trigger
    }

})();

var footerLocationController = (function(){

	var $chosen =  $('.footer_location_chosen'),
		$option = $chosen.find('.chosen_option'),
		$content  = $('.contacts_location .chosen_content'),

		showContent = function( location ){

			var $selectedContent = $content.filter(function(){
				return $(this).data('location-content') == location
			});

			$content.removeClass('-active');
			$selectedContent.addClass('-active');
		},

		trigger = function( location ){
			$option.filter(function(){
				return $(this).data('location') == location
			}).trigger('click.chosen');

			showContent(location);
		}

	$option.on('click', function(){
		var selectedOption = $(this).data('location');
		$(document).trigger('changeLocation', [ selectedOption ]);
	});

	return{
		trigger: trigger
	}

})();
(function(){

	$(document).on('click', '.cta-video_play-btn', function(){

		var videoSrc = $(this).data('video'),
			$overlay = $(this).parent(),
			$iframe = $('<iframe/>',{
			frameborder: 0,
			allowfullscreen: true,
			src: videoSrc
		}).insertAfter($overlay);

		$overlay.fadeOut(300);
	});

	$('#events_month').change(function(){
		var month = $(this).val();
		$('.future-events').find('.events-wrap, .event').remove();
		$('.future-events').find('h3, p, i').remove();
		$('.future-events').append("<i class='icon icon-loader'></i>");
		$.ajax({
			url: ajaxurl,
			type: 'POST',
			data: 'action=get_events_for_month&month=' + month,
			dataType: 'JSON'
		}).success(function(data){
			if (data['data'].length){
				var html = "<div class='events-wrap'>";
				html += "<h3>"+data['month']+" "+data['year']+"</h3>";
				$.each(data['data'], function (index, value) {
					html += "<div class='event'>";
					html += "<div class='image-wrap' style='background-image: url("+data['data'][index].image+")'></div>";
					html += "<div class='content'>";
					html += "<h5>"+data['data'][index].title+"</h5>";
					html += "<p>";
					html += "<span class='date'>"+data['data'][index].date+"</span> ";
					html += data['data'][index].start_time+" - "+data['data'][index].end_time;
					html += "</p>";
					html += "<a href='"+data['data'][index].url+"'>"+data['data'][index].link_text+"</a>";
					html += "</div>";
					html += "</div>";
				  });
				html += "</div>";
				$('.future-events').find('i').remove();
				$('.future-events').append(html);
			}else{
				$('.future-events').find('i').remove();
				$('.future-events').append("<p class='error'>No events found for this month</p>");
			}
		});
	});

})();
var blogListModule = (function(){

	var $items = $('.blog-items_list .blog-item'),
		$programmeItemHeader = $('.programme-item .blog-item_header a'),

		shiftUpContainer = function( $item ){
			var $container = $item.find('.blog-item_container');
			$container.stop(true, true)
				.animate({top: 0}, 300);
				$item.addClass('-hover');
		},

		shiftDownContainer = function( $item ){
			var $container = $item.find('.blog-item_container');
			$container.stop(true, true)
				.animate({
					top: calculateShift($container)
				});
				$item.removeClass('-hover');
		},

		calculateShift = function( $container ){
			var $header = $container.find('.blog-item_header'),
				shift = $container.height() - ( $header.position().top + $header.outerHeight() );


			return shift;
		},

		setItemsShift = function(){
			$items.each(function() {
				var $container = $(this).find('.blog-item_container');
				$container.css({
					top: calculateShift($container),
					opacity: 1
				});
			});
		},

		headerNowrap = function(){
			$programmeItemHeader.each(function(){
				var $text = $(this),
					words = $.trim($text.text()).split(' '),
					icon = $text.find('.icon-action-arrow');

				var lastWord = words.splice(words.length - 1, 1);

				$text.text(words.join(' ') + ' ')
					.append('<span> '+ lastWord + ' </span>')
					.find('span')
					.append(icon);

            })
        };

		$programmeItemHeader.length && headerNowrap();

	//binding

	media('screen and (min-width: 680px)', function(){

		if (!isTouch){

			$items.set('mouseenter', function(){
				shiftUpContainer( $(this) );
			});

			$items.set('mouseleave', function(){
				shiftDownContainer( $(this) );
			});

		}else{

			$items.set('tap', function(event){
				var $item = $(this);
				shiftUpContainer( $item );

				$item.outside('tap', function(){
					shiftDownContainer( $item );
				});
			});

		}

	}, function(){

		$items.unset('mouseenter');
		$items.unset('mouseleave');
		$items.unset('tap');

	});

	return{
		setItemsShift: setItemsShift
	}

})();


$(window).on('resize load', function(){
	blogListModule.setItemsShift();
});
function changeVisibility(element) {
	var elementaddthis = element.parentElement.getElementsByClassName('addthis_toolbox')[0];
    if (elementaddthis.style.visibility == 'visible') {
        elementaddthis.style.visibility = 'hidden';
    } else {
        elementaddthis.style.visibility = 'visible';
    }
}
(function(){

})();
var mobileMenuModule = (function(){

	var $menuOpenBtn = $('.btn-menu-open'),
		$menuCloseBtn = $('.btn-menu-close'),
		$mobileMenu = $('.mobile-menu'),
		$mobileMenuLink = $('.mobile-menu_link.-has-sub'),
		$mobileMenuLinkBtn = $('.mobile-menu_link.-has-sub .icon-arrow-down'),
		$body = $('body'),
		$locationSelect = $('.mobile-menu_select.-location'),
		$languageSelect = $('.mobile-menu_select.-language'),
		$backdrop = $('.backdrop'),

		openMenu = function(){

			$mobileMenu.show()
				.stop(true, true)
				.animate({top: 0}, 300);

			$body.addClass('backstage');
			$menuOpenBtn.hide();
			$menuCloseBtn.show();
		},

		closeMenu = function(){
			$mobileMenu.stop(true, true).animate({top: '-100%'}, 300, function(){
				$mobileMenu.hide()
			});
			$body.removeClass('backstage');
			$menuOpenBtn.show();
			$menuCloseBtn.hide();
		},

		disableMenu = function(){
			closeMenu();
			$menuOpenBtn.removeAttr('style');
		},

		openSubMenu = function($subMenu){
			$subMenu.slideDown();
		},

		closeSubMenu = function($subMenu){
			$subMenu.slideUp();
		},

		trigger = function( location ){
			$locationSelect.val(location);
		},

		isLink = function( url ){
			var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
			return regexp.test(url);
		},

		changeCountry = function(link){
			window.location.href = link;

		},

		changeLocation = function( location ){
			$locationSelect.val( location );
		},

		cloneLanguageMenu = function(){
			var $hoverSelect = $languageSelect.clone();
			$hoverSelect.addClass('hover-menu');
			$backdrop.addClass('-active');
			$backdrop.append($hoverSelect);
			$hoverSelect.fadeIn(500);
			
			$hoverSelect.on('click', 'a', (function(){
				var link = $(this);
				if(link.parent().hasClass('current-menu-item')){
					destroyHoverSelect($hoverSelect);
					return false;
				}else{
					closeMenu();
					return true;
				}
			}));

			$backdrop.on( 'click' , function(){
				destroyHoverSelect($hoverSelect);
			});
			return false;
		},

		destroyHoverSelect = function( $hoverSelect ){
			$backdrop.removeClass('-active');
			$hoverSelect.remove();
		};

		$menuOpenBtn.on('click', function(){
			openMenu();
		});

		$menuCloseBtn.on('click', function(){
			closeMenu();
		});

		$mobileMenuLinkBtn.on('click', function(event){
			event.stopPropagation();
			var $link = $(this).parent(),
				$target = $link.next();
				console.log('btn', $link, $target);

			if ( $link.hasClass('-active') ){
				closeSubMenu($target);
				$link.removeClass('-active');
			}else{
				openSubMenu($target);
				$link.addClass('-active');
			}

			event.stopPropagation();
			return false;
		});

		$languageSelect.on('click', 'a', function(e){
			e.preventDefault();
			//cloneLanguageMenu();
			return false;
		})


		$languageSelect.on('change', function() {
			var url = this.value;
			window.location.href = url;
		});

		$locationSelect.on('change', function(){
			var $select = $(this),
				selectedOption = $select.val();

			if ( isLink(selectedOption) ){
				changeCountry(selectedOption);
			}else{
				$(document).trigger('changeLocation', [ selectedOption ]);
			}
		});

		return{
			open: openMenu,
			close: closeMenu,
			disable: disableMenu,
			changeLocation: changeLocation
		}
})();

media('screen and (min-width: 680px)', function(){
	mobileMenuModule.disable();
});
(function(){
    var scrollTimeout;

    $(window).on('scroll.facilityPluses', function(){
        if ( scrollTimeout ){
            clearTimeout(scrollTimeout);
            scrollTimeout = null;
        }
        scrollTimeout = setTimeout(scrollHandler, 100);
    });

    function scrollHandler(){
        var $facilityPluses = $('.facility_pluses');

        if ( $facilityPluses.length ){
            var elementTop = $facilityPluses.offset().top,
                scrollTop = $(window).scrollTop() + $(window).outerHeight();

            if ( elementTop < scrollTop && $facilityPluses.is(':visible') ){

                var time = 0;
                $('.facility_pluses_number').each(function(){
                    var element = this;

                    setTimeout(function(){
                        startCounting(element);
                    }, time);
                    time += 500;
                });

                $(window).off('scroll.facilityPluses');
            }
        }
    }

    function startCounting(element){
        var lastChar = $(element).data('number').toString().substr(-1);
        if (!isNaN(parseInt(lastChar))) {
            lastChar = false;
        }

        $(element).prop('counter', 0).animate({
            counter: parseInt($(element).data('number'))
        }, {
            duration: 1000,
            easing: 'swing',
            step: function(now){
                $(element).text(Math.ceil(now) + lastChar);
            }
        });
    }

    //ipad height hack
    //if ( $('.tabs_content.-active .slider').height() == 0
    //    $('.tabs_content.-active .slider').height($('.tabs_content.-active .facility_details_image').height());
    //}

    //set height

})();
var locationPanorama = (function(){

    var init = function(heading, lat, lng){
        var map = new google.maps.Map(document.getElementById('studio-panorama'), {
            zoom: 8,
            scrollwheel: false,
            mapTypeControl: false
        });

        var panorama = new google.maps.StreetViewPanorama(document.getElementById('studio-panorama'), {
            visible: false,
            scrollwheel: false,
            addressControl: false,
            fullscreenControl: false,
            position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng))
        });
        map.setStreetView(panorama);

        if (parseFloat(heading) > 0) {
            panorama.setPov({
                heading: parseFloat(heading),
                pitch: 0
            });
        }
        panorama.setVisible(true);
    };

    return {
        init: init
    }

})();

$(document).ready(function(){
    var $studioPanorama = $('#studio-panorama');

    if ($studioPanorama
        && $studioPanorama.data('panorama-heading')
        && $studioPanorama.data('panorama-lat')
        && $studioPanorama.data('panorama-lng')
    ) {
        locationPanorama.init(
            $studioPanorama.data('panorama-heading'),
            $studioPanorama.data('panorama-lat'),
            $studioPanorama.data('panorama-lng')
        );
    }
});

$.validator.setDefaults({
	submitHandler: function() {
		alert("Success!");
	}
});


$("#download-form-1").validate({
	errorClass: '-error',
	errorPlacement: function(error, element) {
	    element.attr("placeholder", error.text());
	},
	rules: {
		name: "required",
		email: {
			required: true,
			email: true
		}
	},
	messages: {
		name: "Please enter your firstname",
		email: "Please enter a valid email address"
	}
});

$("#download-form-2").validate({
	errorClass: '-error',
	errorPlacement: function(error, element) {
	    element.attr("placeholder", error.text());
	},
	rules: {
		name: "required",
		email: {
			required: true,
			email: true
		}
	},
	messages: {
		name: "Please enter your firstname",
		email: "Please enter a valid email address"
	}
});

$("#download-form-3").validate({
	errorClass: '-error',
	errorPlacement: function(error, element) {
	    element.attr("placeholder", error.text());
	},
	rules: {
		name: "required",
		email: {
			required: true,
			email: true
		}
	},
	messages: {
		name: "Please enter your firstname",
		email: "Please enter a valid email address"
	}
});


$('#backdrop-download-form').validate({
	errorClass: '-error',
	errorPlacement: function(error, element) {
	    element.attr("placeholder", error.text());
	},
	rules: {
		firstname: "required",
		lastname: "required",
		phone: "required",
		date: "required",
		email: {
			required: true,
			email: true
		}
	},
	messages: {
		firstname: "Please enter your firstname",
		lastname: "Please enter your lastname",
		phone: "Please enter your phone",
		date: "Please enter preffered date",
		email: "Please enter a valid email address"
	}
});

$('#contacts-form').validate({
	errorClass: '-error',
	errorPlacement: function(error, element) {
	    element.attr("placeholder", error.text());
	},
	rules: {
		name: "required",
		phone: "required",
		message: "required",
		email: {
			required: true,
			email: true
		}
	},
	messages: {
		name: "Please enter your firstname",
		phone: "Please enter your phone",
		message: "Please enter your message",
		email: "Please enter a valid email address"
	}
});

var contactsLocationController = (function(){

	var $chosen =  $('.contacts_location  .cta-location_chosen'),
		$option = $chosen.find('.chosen_option'),
		$content  = $('.footer_location_content'),

		showContent = function( location ){

			var $selectedContent = $content.filter(function(){
				return $(this).data('location-content') == location
			});

			$content.removeClass('-active');
			$selectedContent.addClass('-active');
		},

		trigger = function( location ){
			$option.filter(function(){
				return $(this).data('location') == location
			}).trigger('click.chosen');

			showContent(location);
		}

	$option.on('click', function(){
		var selectedOption = $(this).data('location');
		$(document).trigger('changeLocation', [ selectedOption ]);
	});

	return{
		trigger: trigger
	}

})();

(function(){


	$(document).on('changeLocation', function(event, location){
		// contactsLocationController.trigger(location);
		// footerLocationController.trigger(location);
		// headerLocationController.trigger(location);
		// mobileMenuModule.changeLocation(location);

		// var currentLocation = abbeyGlobal.locationArray.filter(function(item){
		// 	return item['name'] == location;
		// });

		// $('.cta-map_frame:not([data-single])').mapAddress('setMapCenter', currentLocation[0].lat, currentLocation[0].lng);

		// if (typeof ajaxurl != 'undefined'){

		// 	$.ajax({
		// 		url: ajaxurl,
		// 		type: "GET",
		// 		data: "action=city_change&city=" + location
		// 	});
			
		// }
	});
})();
var coursesFilterController = (function(){
    var $filters = $('select.courses_filter'),
        $resetBtn = $('.courses-filters_reset-btn'),
        $togglerBtn = $('.courses-filters_toggler'),
        $filtersContainer = $('.courses-filters'),
        $emptyMessage = $('.courses_empty-message'),
        $course = $('.course'),
        $template = $('.courses_list.-template'),
        handlebarsSource = $('#courses-template').html(),
        model = {},
        filteredModel = {},

        init = function(){
            $filters.lookDropdown();
            prefillSilngleOptions();

            if ( typeof ajaxurl != 'undefined' ){
                $.ajax({
                    url: ajaxurl,
                    type: 'GET',
                    data: 'action=get_all_courses'

                }).success(function(courses){
                    model = {
                        courses: JSON.parse(courses)
                    };
                });

            } else {
                model = {
                    courses: []
                };

                showCourses(model);
            }
            setEvents();
        },

        prefillSilngleOptions = function(){

            $filters.each(function(){
                var $filter = $(this),
                    $options = $filter.find('option:enabled');

                if ( $options.length == 1 ){
                    $options.val();

                    $filter.data('lookDropdown').$options.trigger('click');
                    $filter.addClass('-disabled').lookDropdown('disable');

                }
            });

        },

        toggleFiltersContainer = function(){
            $filtersContainer.slideToggle(300, function(){
                $(this).toggleClass('-active').removeAttr('style');
            });
            $togglerBtn.toggleClass('-active');
        },

        showCourses = function(modelToShow){

            if ( modelToShow.courses.length == 0 ){
                $emptyMessage.fadeIn()
                modelToShow = model;
            } else {
                $emptyMessage.hide();
            }

            var template = Handlebars.compile(handlebarsSource),
                html = template(modelToShow);

            $template.html(html);

            $course.refresh()
                .hide()
                .fadeIn(500);

        },

        createFilterQuery = function(){
            var query = $filters.filter(function(index, filter){
                if ( filter.selectedOptions.length ){
                    return filter.selectedOptions[0].disabled === false;
                } else {
                    return false;
                }
            }).map(function(index, filter){
                return {
                    name: filter.name,
                    value: $(filter).val()
                }
            });
            filter(query);
        },

        filter = function(query){
            filteredModel.courses = model.courses.filter(function(value, index){
                var matched = [];
                for ( var i = 0; i < query.length; i++ ){
                    matched[i] = query[i].value.some(function(val, index){
                        return value[query[i].name] == val;
                    });
                }
                return matched.every(function(match){
                    return match == true;
                });
            });
            showCourses(filteredModel);
        },

        resetFilters = function(){
            $filters.not('.-disabled').lookDropdown('reinit');
            createFilterQuery();
        };

    var filterData = {
        courses: []
    }

    var setEvents = function(){
        $filters.set('change', function(){
            createFilterQuery();
        });

        $resetBtn.set('click', function(){
            resetFilters();
        });

        $togglerBtn.set('click', function(){
            toggleFiltersContainer();
        });
    }

    return {
        reset: resetFilters,
        init: init
    }
})();

if ( $('#courses-template').length ){
    coursesFilterController.init();
}
var squeeezePageShortcodeModule = (function () {
    
        var $iframe = $('.squeeze-page-iframe'),
    
            initModuleHeight = function (obj) {
                setTimeout(function(){
                try{
                    iFrameResize( [{}, obj] ); 
                }catch(e){
                    
                }
                }, 100);
            };

            triggerSqueezeEvent = function(){
                dataLayer.push({
                    'event' : 'squeeze',
                    'label' : abbeyGlobal.websiteCode,
                    'website code' : abbeyGlobal.websiteCode,
                    'institute_code' : abbeyGlobal.websiteCode
                });
            };


        return {
            initModuleHeight: initModuleHeight,
            triggerSqueezeEvent: triggerSqueezeEvent
        }
    
    })();
var staffListModule = (function(){

	var $trigger = $('.staff-item:not(.-active) .staff-item_name, .staff-item:not(.-active) .staff-item_btn'),
		$itemList = $('.staff-item'),
		$detailsList = $('.staff-details'),

		toggleItemState = function($item){
			$itemList.filter('.-active').removeClass('-active');
			$item.addClass('-active').removeClass('-hover');
			setItemShift($item.find('.staff-item_container'), true);
		},

		toggleItemDetails = function(detailsId){
			var $details = $( detailsId ),
			$detailsActive = $detailsList.filter('.-active');

			if ($detailsActive.length > 0){

				$detailsActive.removeClass('-active').delay(300).slideUp(500, function(){
					$details.slideDown(500, function(){
						$details.addClass('-active');
						scrollTo(detailsId);
					});
				});
			}else{
				$details.slideDown(500, function(){
					$details.addClass('-active');
					scrollTo(detailsId);
				});
			}
		},

		closeItemDetails = function( detailsId ){
			var $details = $( '#' + detailsId ),
				$item = $('.staff-item[data-details="#'+detailsId+'"]');

			$item.removeClass('-active');
			$details.removeClass('-active').slideUp(500);
			stateModule.changeState(window.location.href.split('#')[0]);
		},

		showItemContainer = function($itemContainer){
			$itemContainer.stop(true, true).animate({top: 0}, 300);
		},

		setItemShift = function( $itemContainer, isAnimate){
			var $header = $itemContainer.find('.staff-item_name'),
			shift = $itemContainer.height() - ( $header.position().top + $header.outerHeight(true) );

			(isAnimate)
				? $itemContainer.animate({top: shift}, 300)
				: $itemContainer.css({top: shift}, 300);
		},

		initItemsShift = function(){
			$itemList.find('.staff-item_container').each(function(index, element) {
				setItemShift( $(element) );
			});
		},
		
		scrollTo = function(detailsId){
			var element = $( "[data-details='"+detailsId+"']");
			$('html, body').animate({
				scrollTop: ( element.offset().top + element.outerHeight() - 72 )
			}, 300);
		},

		toggleHash = function(name, id){
			stateModule.changeHash(name);
		},

		hashOpenDetails = function (id){
			var staffHash = window.location.hash;
			var staffName = staffHash.replace("#", '');
			if( staffHash && ari_squeeze && ari_squeeze.indexOf(staffName) == -1 ){
				var url = window.location.href.split('#')[0];
				var staff = $( "[data-staff-name='"+staffName+"']");
				toggleItemDetails( staff.data('details') );
            }
		}

	//details

	// $(document).on('click', '.staff-item:not(.-active) .staff-item_btn', function(){
	// 	$item = $(this).closest('.staff-item');
	// 	toggleItemState( $item );
	// 	toggleItemDetails( $item.data('details') );
	// 	toggleHash($item.data('staff-name'), $item.data('details'));		
	// 	return false;
	// });

	// $(document).on('click', '.staff-item.-active .staff-item_name', function(){
	// 	closeItemDetails( $(this).closest('.staff-item').data('details').replace('#', '') );
	// 	return false;
	// });

	// $(document).on('click', '.staff-details_close-btn', function(){
	// 	var $details = $(this).closest('.staff-details');
	// 	closeItemDetails( $details.attr('id') );
	// 	return false;
	// });

	//hover

	media('screen and (min-width: 680px)', function(){
		if (!isTouch){

			$(document).on('mouseenter', '.staff-item:not(.-active)', function(){
				showItemContainer( $(this).find('.staff-item_container') );
			});

			$(document).on('mouseleave', '.staff-item:not(.-active)', function(){
				setItemShift( $(this).find('.staff-item_container'), true );
			});

			$(document).on('click', '.staff-item:not(.-active) .staff-item_name', function(){
				$item = $(this).closest('.staff-item');
				toggleItemState( $item );
				toggleItemDetails( $item.data('details') );

				return false;
			});

		}else{
			// $(document).on('tap', '.staff-item:not(.-active):not(.-hover)', function(event){
			// 	var $item = $(this);
			// 	showItemContainer( $item.find('.staff-item_container') );
			// 	$item.addClass('-hover');

			// 	$(document).one('tap', 'body', function(event){
			// 		event.stopPropagation();
			// 		setItemShift( $item.find('.staff-item_container'), true );
			// 		$item.removeClass('-hover');
			// 	});
			// });

			// $(document).on('tap', '.staff-item.-hover .staff-item_name', function(){
			// 	$item = $(this).closest('.staff-item');
			// 	toggleItemState( $item );
			// 	toggleItemDetails( $item.data('details') );

			// 	return false;
			// });

		}
	}, function(){

		$(document).on('click', '.staff-item:not(.-active) .staff-item_name', function(){
			$item = $(this).closest('.staff-item');
			toggleItemState( $item );
			toggleItemDetails( $item.data('details') );

			return false;
		});
	});

	return{
		initItemsShift: initItemsShift,
		hashOpenDetails: hashOpenDetails
	}
})();


$(window).on('resize load', function(){
	staffListModule.initItemsShift();
});

$(window).on('load', function(){
	try{
		staffListModule.hashOpenDetails();
	}catch(e){
		
	}
    
})
var landingPageModule = (function () {
    
    var $iframe = $('#landing-page-iframe'),
    $introWrap = $('.intro-wrap'),
    $introBlockText = $('.intro-block_text'),
    $videoTag = $('#hero-video'),
    introMaxHeight = 160,
    initYt = function(id, width, height){
        if(!width){
          width  = $('.landing-video-wrap').width();
          height  = $('.landing-video-wrap').height();
        }
        var check = !window.mobileAndTabletcheck() ? 1 : 0;
        YTplayer = new YT.Player('landing-video-player', {
            width: width,
            height: height,
            videoId: id,
            playerVars: {
                autoplay: check,
                controls: 0, 
                rel : 0,
                fs : 0,
                showinfo: 0
              }
        });
    },
    initReadMore = function(){
   
        var textH = $introBlockText.outerHeight();
        console.log(textH, introMaxHeight);
       if ( textH > introMaxHeight ) {

           $('.read-more').on('click', function(){

                $introWrap.addClass('active');
                
           });
       }
    };

    if($introBlockText.length){
        initReadMore();
        $(window).resize(function(){
            initReadMore();
        });
    };

    if($videoTag.length){
        $('.landing-video-wrap').find('video').get(0).play();
    }

    return {
        initYt: initYt,
    }

})();


$(document).ready(function(){
    window.mobileAndTabletcheck = function() {
		var check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	};
    $('.landing-video-wrap .play-icon').click(function(e){
        e.preventDefault();
        var id = $(this).attr('data-video-id');
        var width = $('.landing-video-wrap').outerWidth();
        var height = $('.landing-video-wrap').outerHeight();
        landingPageModule.initYt(id, width, height);
    });
});
var captchaModule = (function($){
    var captchaBtn = $('.ari-refresh-captcha'),
    hexToBase64 = function(str){
        return btoa(String.fromCharCode.apply(null, str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")));
    },

    refreshCaptcha = function(){
        if ( typeof ajaxurl != 'undefined' ){
            $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: 'action=get_new_captcha'

            }).success(function(data){
                captchaBtn.removeClass('animated');
                $('#captcha-img').attr('src',  data);
            });

        }
    };

    captchaBtn.click(function(e){
        e.preventDefault();
        captchaBtn.addClass('animated');
        refreshCaptcha();
    });
    
    // $(window).load(function(){
    //     if(captchaBtn.length > 0){
    //         refreshCaptcha();
    //     }
    // })

    return{
        refreshCaptcha: refreshCaptcha
    }
})($);
var locationModule = (function(){
    var  $heroSliderSection = $('.location-hero__slider'),
    $heroSliderWrapper = $('.location-hero__slider .owl-carousel'),
    $fullscreen = $('.fullscreen'),
    $current = $('.slider-current .current'),
    $total = $('.slider-current .total'),
    $closeFullScreen = $('.close-full-screen'),
    $studioSliderWrap = $('.studio-slider-wrap  .owl-carousel'),
    $surroundingsSliderWrap = $('.surroundings-slider-wrap  .owl-carousel' ),
    $testimonialsSliderWrap = $('.testimonials-slider .owl-carousel'),
    testimonialsSlider = undefined,
    studioSlider = undefined,
    surroundingsSlider = undefined,
    heroSlider = undefined,
    heroFullScreen = false,
    initHeroSlider = function(){
        heroSlider = $heroSliderWrapper.owlCarousel({
            loop: true,
            margin:30,
            autoWidth: true,
            nav: false,
            autoplay: true,
            autoplaySpeed: 700,
            speed: 7000,
            slideBy: 1,
            onChanged: onHeroChanged,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:3
                },
                1000:{
                    items:3
                }
            }
        });
        $('.hero-slider-next').click(function() {
            heroSlider.trigger('next.owl.carousel');
        })
        $('.hero-slider-prev').click(function() {
            heroSlider.trigger('prev.owl.carousel');
        })
    },
    initStudioSlider = function(){
        studioSlider = $studioSliderWrap.owlCarousel({
            loop: true,
            margin: 30,
            autoWidth: false,
            dots: false,
            nav: false,
            slideBy: 1,
            items: 1,
            animateOut: 'fadeOut'
        });
        $('.studio-slider-next').click(function() {
            studioSlider.trigger('next.owl.carousel');
        })
        $('.studio-slider-prev').click(function() {
            studioSlider.trigger('prev.owl.carousel');
        })
    },
    initSurroundingSlider = function(){
        surroundingsSlider = $surroundingsSliderWrap.owlCarousel({
            loop: true,
            margin: 30,
            autoWidth: false,
            dots: false,
            nav: false,
            slideBy: 1,
            items: 1,
            animateOut: 'fadeOut'
        });
        $('.surroundings-slider-next').click(function() {
            surroundingsSlider.trigger('next.owl.carousel');
        })
        $('.surroundings-slider-prev').click(function() {
            surroundingsSlider.trigger('prev.owl.carousel');
        })
    },
    initTestimonialsSlider = function(){
        testimonialsSlider = $testimonialsSliderWrap.owlCarousel({
            loop: true,
            margin: 30,
            autoWidth: false,
            dots: false,
            nav: false,
            slideBy: 1,
            items: 1,
        });
        $('.testimonials-slider-next').click(function() {
            testimonialsSlider.trigger('next.owl.carousel');
        })
        $('.testimonials-slider-prev').click(function() {
            testimonialsSlider.trigger('prev.owl.carousel');
        })
    },
    onHeroChanged = function(e){
        if(e.page.index >= 0){
            var current = e.page.index + 1;
            var total = e.page.count;
            $current.text(current);
            $total.text(total);
        }
    }

    $fullscreen.click(function(){
        if(!$heroSliderSection.hasClass('full')){
            $heroSliderSection.addClass('full');
            $.each($heroSliderWrapper.find('img'), function(index, element){
                $(element).attr('src', $(element).attr('data-full-src'));
            });
            $heroSliderWrapper.owlCarousel('destroy');
            $heroSliderWrapper.owlCarousel({
                items: 1,
                loop: true,
                margin:30,
                autoWidth: true,
                nav: false
            });
        }else{
            $heroSliderSection.removeClass('full');
            $.each($heroSliderWrapper.find('img'), function(index, element){
                $(element).attr('src', $(element).attr('data-thumbnail-src'));
            });
            $heroSliderWrapper.owlCarousel('destroy');
            initHeroSlider();
        }
        
    });

    $closeFullScreen.click(function(){
        $heroSliderSection.removeClass('full');
        $.each($heroSliderWrapper.find('img'), function(index, element){
            $(element).attr('src', $(element).attr('data-thumbnail-src'));
        });
        $heroSliderWrapper.owlCarousel('destroy');
        initHeroSlider();
    });

    if($heroSliderWrapper.length){
        initHeroSlider();
    }

    if($studioSliderWrap.length){
        initStudioSlider();
    }

    if($surroundingsSliderWrap.length){
        initSurroundingSlider();
    }

    if($testimonialsSliderWrap.length){
        initTestimonialsSlider();
    }


})();
var locationNewModule = (function(){
    var  $facilitiesSlider = $('.facilities-gallery-wrap'),
    $locationFacilitiesSlider = $('.location-facilities-gallery-wrap'),
    $locationDetailsSlider = $('.location-details-gallery'),
    facilitiesSlider = undefined,
    locationFacilitiesSlider = undefined,
    locationDetailsSlider = undefined,
    initFacilitiesSlider = function(){
        facilitiesSlider = $facilitiesSlider.owlCarousel({
            loop: true,
            margin: 30,
            autoWidth: false,
            dots: false,
            nav: false,
            slideBy: 1,
            items: 3.5,
            responsive: {
                0: {
                    items: 1,
                },
                980: {
                    items: 3.5,
                }
            }
        });
        $('.facilities-slider-next').click(function() {
            facilitiesSlider.trigger('next.owl.carousel');
        })
        // $('.studio-slider-prev').click(function() {
        //     studioSlider.trigger('prev.owl.carousel');
        // })
    },
    initLocationFacilitiesSlider = function(){
        locationFacilitiesSlider = $locationFacilitiesSlider.owlCarousel({
            loop: true,
            center: true,
            margin: 30,
            autoWidth: false,
            dots: false,
            nav: false,
            slideBy: 1,
            items: 1.8,
            responsive: {
                0: {
                    items: 1.2,
                },
                980: {
                    items: 1.8,
                }
            }
        });
        $('.location-facilities-slider-next').click(function() {
            locationFacilitiesSlider.trigger('next.owl.carousel');
        })
        $('.location-facilities-slider-prev').click(function() {
            locationFacilitiesSlider.trigger('prev.owl.carousel');
        })
    },
    initLocationDetailsSlider = function(){
        locationDetailsSlider = $locationDetailsSlider.owlCarousel({
            loop: true,
            margin: 30,
            autoWidth: false,
            dots: false,
            nav: false,
            slideBy: 1,
            items: 1.5,
            responsive: {
                0: {
                    items: 1,
                },
                980: {
                    items: 1.5,
                }
            }
        });
        $('.location-details-slider-next').click(function() {
            locationDetailsSlider.trigger('next.owl.carousel');
        })
    };

    if($facilitiesSlider.length){
        initFacilitiesSlider();
    }

    if($locationFacilitiesSlider.length){
        initLocationFacilitiesSlider();
    }
    if($locationDetailsSlider.length){
        initLocationDetailsSlider();
    }


})();
var locationOverlayModule = (function(){
    var  $locationOverlay = $('.location-overlay'),
    $overlayContent = $('.location-overlay > .content'),
    $body = $('body'),
    $overlayFacilityTrigger = $('.btn-facility-overlay'),
    $overlayClose = $('.close-overlay'),
    $overlayGalleryWrap = $('.overlay-gallery-wrap'),
    $overlayFacilitiesGallery = $('.overlay-facilities-gallery'),
    overlayGallerySlider = undefined,
    overlayRelatedSlider = undefined,
    overlayActive = false,
    showOverlay = function(id){
        if(!overlayActive){
            $locationOverlay.addClass('active');
            $body.addClass('overlay-active');
            overlayActive = true;
        }
    },
    hideOverlay = function(){
        if(overlayActive){
            $locationOverlay.removeClass('active');
            $body.removeClass('overlay-active');
            overlayActive = false;
            stateModule.removeHash();
        }
    },
    getOverlayActive = function(){
        return overlayActive;
    },

    resetOverlayConent = function(){
        $overlayContent.html("");
    },
    initOverlayGallerySlider = function(){
        $('.overlay-gallery-wrap').owlCarousel('destroy');
        overlayGallerySlider = undefined;
        overlayGallerySlider = $('.overlay-gallery-wrap').owlCarousel({
            loop: true,
            center: true,
            margin: 30,
            autoWidth: false,
            dots: false,
            nav: false,
            slideBy: 1,
            items: 1.8,
            responsive: {
                0: {
                    items: 1.2,
                },
                980: {
                    items: 1.8,
                }
            }
        });
        $('.overlay-slider-next').click(function() {
            overlayGallerySlider.trigger('next.owl.carousel');
        })
        $('.overlay-slider-prev').click(function() {
            overlayGallerySlider.trigger('prev.owl.carousel');
        })
    },
    initOverlayFacilitiesSlider = function(){
        $('.overlay-facilities-gallery').owlCarousel('destroy');
        overlayRelatedSlider = undefined;
        overlayRelatedSlider = $('.overlay-facilities-gallery').owlCarousel({
            loop: true,
            margin: 30,
            autoWidth: false,
            dots: false,
            nav: false,
            slideBy: 1,
            items: 3.5,
            responsive: {
                0: {
                    items: 1,
                },
                980: {
                    items: 3.5,
                }
            }
        });
        $('.overlay-facilities-slider-next').click(function() {
            overlayRelatedSlider.trigger('next.owl.carousel');
        })
    };

    $overlayFacilityTrigger.click(function(e){
        e.preventDefault();

        resetOverlayConent();
        $('.overlay-loading').removeClass('-loading');
        var slug = $(this).attr('data-slug');

        var link = $(this);

        link.addClass('-loading');

        var facilityId = link.attr('data-id');
        var action = link.attr('data-action');

        var action = !action ? 'get_facility_markup&facility_id='+facilityId : 'get_location_markup&location_id='+facilityId;

        jQuery.ajax({
            url: ajaxurl,
            type: 'POST',
            data: 'action='+action

        }).success(function(data){

            $overlayContent.html(data);
            showOverlay();
            link.removeClass('-loading');

            $overlayContent.on('click', '.header_btn', function(e){

                var $btn = $(this),
                target = $btn.data('modal');
                e.stopPropagation();
    
                (target.indexOf('#') == 0)
                    ? backdropModule.showModalId(target)
                    : backdropModule.showModalAjax(target, $btn);
                
                stateModule.parseHash(target);
            });
            initOverlayGallerySlider();
            initOverlayFacilitiesSlider();

            $overlayContent.on('click', '.tab-title',  function(){
                var tabIndex = $(this).index();
                $('.tab-title.active').removeClass('active');
                $('.tab-content.active').removeClass('active');
                $(this).addClass('active');
                $('.tab-content:eq('+tabIndex+')').addClass('active');
            });

            $overlayContent.on('click', '.btn-overlay-reload', function(e){
                e.preventDefault();
                var facility_link = $(this);
                $overlayContent.addClass('loading');
                facility_link.addClass('--loading');
                var slug = $(this).attr('data-slug');
                
                var facilityId = facility_link.attr('data-id');
                var action = 'get_facility_markup&facility_id='+facilityId;
                $overlayContent.html("");
                jQuery.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: 'action='+action
        
                }).success(function(data){
                    $overlayContent.html(data);
                    initOverlayGallerySlider();
                    initOverlayFacilitiesSlider();
                    $overlayContent.removeClass('loading');
                    facility_link.removeClass('--loading');
                    stateModule.removeHash();
                    stateModule.changeHash(slug);
                });
            });
        });

        stateModule.changeHash(slug);

        
    });

    $overlayContent.on('click', '.close-overlay', function(e){
        resetOverlayConent();
        hideOverlay();
    });

    $locationOverlay.click(function(e){
        e.preventDefault();
        e.stopPropagation();
        if(overlayActive){
            hideOverlay();
        }
    });

    $(document).ready(function(){
        var urlHash = window.location.hash;
        if(urlHash){
            var slug = urlHash.replace("#", '');
            var button = $(".btn-facility-overlay[data-slug='" + slug + "']"); 
            if(button){
                $(button).trigger('click');
            }
        }
    });

    $overlayContent.click(function(e){
        e.stopPropagation();
    });
    
    return{
        show: showOverlay,
        hide: hideOverlay,
        active: getOverlayActive
    }

})();
$(document).ready(function () {
    var bigimage = $("#big");
    var thumbs = $("#thumbs");
    //var totalslides = 10;
    var syncedSecondary = true;

     var big = bigimage
        .owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: true,
            autoplay: false,
            dots: false,
            loop: true,
            responsiveRefreshRate: 200,
            navText: [
                '<span class="studio-prev"></span>',
                '<span class="studio-next"></span>'
            ],
        });

        big.on("changed.owl.carousel", syncPosition);


    thumbs
        .on("initialized.owl.carousel", function () {
            thumbs
                .find(".owl-item")
                .eq(0)
                .addClass("current");
        })
        .owlCarousel({
            items: 6,
            dots: true,
            nav: false,
            smartSpeed: 200,
            slideSpeed: 500,
            slideBy: 1,
            autoplay: false,
            responsiveRefreshRate: 100
        })
        .on("changed.owl.carousel", syncPosition2);

    function syncPosition(el) {
        //if loop is set to false, then you have to uncomment the next line
        //var current = el.item.index;

        //to disable loop, comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }
        //to this
        thumbs
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = thumbs.find(".owl-item.active").length - 1;
        var start = thumbs
            .find(".owl-item.active")
            .first()
            .index();
        var end = thumbs
            .find(".owl-item.active")
            .last()
            .index();

        if (current > end) {
            thumbs.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
            thumbs.data("owl.carousel").to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            bigimage.data("owl.carousel").to(number, 100, true);
        }
    }

    thumbs.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        bigimage.data("owl.carousel").to(number, 300, true);
    });

    setTimeout(function(){
        jQuery('#big').trigger('refresh.owl.carousel');
    }, 500);
});